
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
class $6ddf3305f4329b40$export$4fae95256245c8c0 {
    on(event, listener) {
        if (typeof this.events[event] !== "object") this.events[event] = [];
        this.events[event].push(listener);
        return ()=>this.off(event, listener);
    }
    off(event, listener) {
        if (typeof this.events[event] !== "object") return;
        this.events[event] = this.events[event].filter((eventListener)=>eventListener !== listener);
    }
    offAll() {
        Object.keys(this.events).forEach((event)=>this.events[event] = []);
    }
    emit(event, ...args) {
        if (typeof this.events[event] === "object") [
            ...this.events[event]
        ].forEach((listener)=>listener.apply(this, args));
        [
            ...this.events["*"]
        ].forEach((listener)=>listener.apply(this, [
                event,
                ...args
            ]));
    }
    once(event, listener) {
        const remove = this.on(event, (...args)=>{
            remove();
            listener.apply(this, args);
        });
        return remove;
    }
    constructor(){
        this.events = {
            "*": []
        };
    }
}


class $8fa72f61f485ea6c$export$2e2bcd8739ae039 extends (0, $6ddf3305f4329b40$export$4fae95256245c8c0) {
    /**
     * Component state change logic
     *
     * @param newState state value to change
     * @param preventRender If true, no rendering is done after the state is changed.
     * @param callback If set, called back if state has changed.
     */ setState(newState, preventRender, callback) {
        if (!this.checkNeedUpdate(newState)) return;
        if (this.state) this.state = {
            ...this.state,
            ...newState
        };
        else this.state = {
            ...newState
        };
        if (callback) {
            callback();
            return;
        }
        if (preventRender) return;
        this.render();
    }
    /**
     * Component state validation, basic... can use more advanced like fast-deep-equal package
     *
     * @param newState state value to validate
     */ checkNeedUpdate(newState) {
        const prevState = JSON.stringify({
            ...this.state
        });
        const currentState = JSON.stringify({
            ...this.state,
            ...newState
        });
        return prevState !== currentState;
    }
    constructor({ $target: $target, initialState: initialState }){
        super();
        this.$target = $target;
        this.state = initialState;
        this.init();
        this.render();
    }
}



function $fb6f3ecaa0346039$export$89a7e74069fbb7af(params = {}) {
    let queryString = "";
    Object.keys(params).forEach((key)=>{
        if (queryString.length !== 0) queryString += "&";
        queryString += key + "=" + params[key].toString();
    });
    return queryString;
}
function $fb6f3ecaa0346039$export$b89605802fcf91d2(polylineString, precision = 5) {
    const coordinates = [];
    const factor = Math.pow(10, precision);
    let index, lat, lng, byte, shift, result, latitude_change, longitude_change;
    index = 0;
    lat = 0;
    lng = 0;
    while(index < polylineString.length){
        byte = null;
        shift = 0;
        result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        latitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        shift = result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        longitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        lat += latitude_change;
        lng += longitude_change;
        coordinates.push([
            lat / factor,
            lng / factor
        ]);
    }
    return coordinates;
}
function $fb6f3ecaa0346039$export$61fc7d43ac8f84b0(callback, timeout) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            callback(...args);
        }, timeout);
    };
}
function $fb6f3ecaa0346039$export$37827d046293d309(text) {
    const canvas = document.getElementById("canvasMarkerWoosmap") || document.createElement("canvas");
    canvas.id = "canvasMarkerWoosmap";
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    context.font = "bold 15px sans-serif";
    return context.measureText(text).width;
}
function $fb6f3ecaa0346039$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object" && input !== null && !Array.isArray(input);
}
function $fb6f3ecaa0346039$export$4950aa0f605343fb(target, source) {
    if (!$fb6f3ecaa0346039$export$a6cdc56e425d0d0a(source) || !$fb6f3ecaa0346039$export$a6cdc56e425d0d0a(target)) return target;
    for(const key in source){
        const targetProp = target[key];
        const sourceProp = source[key];
        if ($fb6f3ecaa0346039$export$a6cdc56e425d0d0a(sourceProp) && $fb6f3ecaa0346039$export$a6cdc56e425d0d0a(targetProp)) $fb6f3ecaa0346039$export$4950aa0f605343fb(targetProp, sourceProp);
        else if (!(key in target)) target[key] = source[key];
    }
    return target;
}
function $fb6f3ecaa0346039$export$77ad94ebf1c2b9ed(str, keyValues) {
    let result = str;
    Object.keys(keyValues).forEach((key)=>{
        result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), keyValues[key]);
    });
    return result;
}
function $fb6f3ecaa0346039$export$a360ab73c4a4e345(url) {
    try {
        const searchParams = new URLSearchParams(url);
        const parameters = {};
        searchParams.forEach((value, key)=>{
            parameters[key] = isNaN(Number(value)) ? decodeURIComponent(value) : Number(value);
        });
        return parameters;
    } catch (error) {
        console.error(`Error parsing URL parameters: ${error}`);
        return null;
    }
}
function $fb6f3ecaa0346039$export$f394dc66b1ba32c3(dateString) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return false;
    const dateParts = dateString.split("-");
    const year = parseInt(dateParts[0]);
    const month = parseInt(dateParts[1]) - 1;
    const day = parseInt(dateParts[2]);
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}


/**
 * Previously loading/loaded scripts that have been requested by `loadScript()`.
 */ let $5a3b137193fd24f6$var$cachedScripts = {};
function $5a3b137193fd24f6$export$2cb99e4be0dc4646(options) {
    const { url: url, params: params, override: override } = options;
    if (!url || url.length === 0) throw new Error("Invalid url.");
    if (typeof params !== "undefined" && typeof params !== "object") throw new Error("Expected params to be an object.");
    const src = `${url}?${(0, $fb6f3ecaa0346039$export$89a7e74069fbb7af)(params)}`;
    const existing = $5a3b137193fd24f6$var$cachedScripts[src];
    if (existing) {
        if (override) {
            const script = $5a3b137193fd24f6$var$getScriptElement(src);
            if (script) {
                delete $5a3b137193fd24f6$var$cachedScripts[src];
                script.remove();
            }
        } else return existing;
    }
    const promise = new Promise((resolve, reject)=>{
        if ($5a3b137193fd24f6$var$findScript(src)) resolve();
        const script = $5a3b137193fd24f6$export$28503efd90ff36be(url, params);
        const onScriptLoad = ()=>{
            resolve();
        };
        const onScriptError = ()=>{
            cleanup();
            delete $5a3b137193fd24f6$var$cachedScripts[src];
            script.remove();
            const defaultError = new Error(`The script "${src}" failed to load.`);
            reject(defaultError);
        };
        script.addEventListener("load", onScriptLoad);
        script.addEventListener("error", onScriptError);
        document.head.insertBefore(script, document.head.firstElementChild);
        function cleanup() {
            script.removeEventListener("load", onScriptLoad);
            script.removeEventListener("error", onScriptError);
        }
    });
    $5a3b137193fd24f6$var$cachedScripts[src] = promise;
    return promise;
}
/**
 * Find script src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {boolean | null} returns `true` if script exist otherwise `null`.
 */ function $5a3b137193fd24f6$var$findScript(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return true;
}
/**
 * Get script by src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {HTMLScriptElement | null} returns existing `HTMLScriptElement` if script exist otherwise `null`.
 */ function $5a3b137193fd24f6$var$getScriptElement(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return currentScript;
}
function $5a3b137193fd24f6$export$28503efd90ff36be(url, params = {}) {
    const newScript = document.createElement("script");
    newScript.src = `${url}?${(0, $fb6f3ecaa0346039$export$89a7e74069fbb7af)(params)}`;
    newScript.async = true;
    return newScript;
}
function $5a3b137193fd24f6$export$41a88579f6bd1282() {
    $5a3b137193fd24f6$var$cachedScripts = {};
}


class $30562ad46da16b22$export$2e2bcd8739ae039 {
    getIconType(options) {
        if (options.selected) return "selectedIcon";
        else return "icon";
    }
    getStyledIcon(options = {}) {
        let matchedIcon;
        const iconType = this.getIconType(options);
        const defaultIcon = this.style.default[iconType];
        if (defaultIcon !== undefined) matchedIcon = {
            icon: defaultIcon
        };
        else matchedIcon = {
            icon: this.style.default.icon
        };
        if (options.types !== undefined && this.style.rules) {
            for (const rule of this.style.rules)for (const type of options.types){
                const ruleIcon = rule[iconType];
                if (rule.type === type) {
                    if (ruleIcon) return {
                        icon: ruleIcon,
                        type: type
                    };
                }
            }
        }
        return matchedIcon;
    }
    constructor(style){
        this.style = style;
    }
}



/**
 * Language: English.
 */ var $24eea19f0baca79b$export$2e2bcd8739ae039 = {
    time: {
        openingHoursTitle: "Opening hours",
        at: "at",
        opensToday: "Opens today",
        opens: "Opens",
        open24_7: "Open 24/7",
        closed: "Closed",
        openUntil: "Open until",
        daily: "Daily opened",
        month: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthAbbr: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        dayOfWeek: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayOfWeekAbbr: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        eventCountdown: "Next event in",
        days: "days",
        hours: "hours",
        tomorrow: "Next event tommorow",
        today: "Today"
    },
    search: {
        placeholder: "Search a location...",
        submitLabel: "Search",
        clearLabel: "Clear Search",
        yourLocation: "Your location"
    },
    filtering: {
        servicesTitle: "Filters",
        services: {
            AR: "Archery",
            ARG: "Artistic Gymnastics",
            ARS: "Artistic Swimming",
            ATH: "Athletics",
            BDM: "Badminton",
            BKB: "Basketball",
            BK3: "3x3 Basketball",
            BV: "Beach Volleyball",
            BOX: "Boxing",
            BKG: "Breaking",
            CSL: "Canoe Slalom",
            CSP: "Canoe Sprint",
            BMF: "Cycling BMX Freestyle",
            BMX: "Cycling BMX Racing",
            MTB: "Cycling Mountain Bike",
            CRD: "Cycling Road",
            CTR: "Cycling Track",
            DIV: "Diving",
            EQU: "Equestrian",
            FEN: "Fencing",
            FB: "Football",
            GLF: "Golf",
            HBL: "Handball",
            HOC: "Hockey",
            JUD: "Judo",
            OWS: "Marathon Swimming",
            MPN: "Modern Pentathlon",
            GRY: "Rhythmic Gymnastics",
            ROW: "Rowing",
            RU7: "Rugby Sevens",
            SAL: "Sailing",
            SHO: "Shooting",
            SKB: "Skateboarding",
            CLB: "Sport Climbing",
            SRF: "Surfing",
            SWM: "Swimming",
            TTE: "Table Tennis",
            TKW: "Taekwondo",
            TEN: "Tennis",
            GTR: "Trampoline Gymnastics",
            TRI: "Triathlon",
            VVO: "Volleyball",
            WPO: "Water Polo",
            WLF: "Weightlifting",
            WRE: "Wrestling"
        }
    },
    stores: {
        cta: {
            call: "Call",
            directions: "Directions",
            website: "Website"
        },
        messages: {
            initialHeader: "Start by searching a locality to display nearby sites",
            emptyHeader: "No results returned",
            initialBody: "or click on the Map to select a site",
            emptyBody: "Please Search a locality elsewhere or unselect your filters"
        },
        types: {
            major: "Celebration site",
            minor: "Visited place"
        },
        name: {
            Stage: "Stage"
        }
    },
    directions: {
        avoidOptions: {
            highways: "Highways",
            tolls: "Tolls",
            ferries: "Ferries"
        },
        avoidTransitOptions: {
            train: "Train",
            bus: "Bus",
            ferries: "Ferries",
            aerial: "Aerial"
        },
        unitOptions: {
            METRIC: "km",
            IMPERIAL: "miles"
        },
        options: "Route options",
        avoid: "Avoid",
        units: "Distance units",
        messages: {
            initialBody: "Search an origin and destination to see available routes and time travel.",
            error: "Sorry, we could not calculate driving directions",
            from: "from",
            to: "to",
            forTravelMode: "for the travel mode",
            via: "through",
            details: "Details",
            withoutTraffic: "without traffic",
            openGoogleMaps: "open in google maps",
            take: "Take",
            walk: "Walk",
            the: "the"
        },
        transit: {
            "train": "train",
            "bus": "bus",
            "ferries": "ferry",
            "aerial": "a\xe9rien",
            "tram": "tram",
            "rail": "train"
        }
    },
    errors: {
        loadingLibrary: "failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    },
    map: {
        showRoute: "Show Route"
    }
};


/**
 * Language: Français.
 */ var $42d54ebdf40f9ebe$export$2e2bcd8739ae039 = {
    time: {
        openingHoursTitle: "Horaires d'ouverture",
        at: "\xe0",
        opensToday: "Ouvre aujourd'hui",
        opens: "Ouvre",
        open24_7: "Ouvert 24/7",
        closed: "Ferm\xe9",
        openUntil: "Ouvert jusqu'\xe0",
        daily: "Ouvert tous les jours",
        month: [
            "Janvier",
            "F\xe9vrier",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Ao\xfbt",
            "Septembre",
            "Octobre",
            "Novembre",
            "D\xe9cembre"
        ],
        monthAbbr: [
            "Jan",
            "F\xe9v",
            "Mars",
            "Avr",
            "Mai",
            "Juin",
            "Juil",
            "Ao\xfbt",
            "Sept",
            "Oct",
            "Nov",
            "D\xe9c"
        ],
        dayOfWeek: [
            "Dimanche",
            "Lundi",
            "Mardi",
            "Mercredi",
            "Jeudi",
            "Vendredi",
            "Samedi"
        ],
        dayOfWeekAbbr: [
            "Dim",
            "Lun",
            "Mar",
            "Mer",
            "Jeu",
            "Ven",
            "Sam"
        ],
        eventCountdown: "Prochain \xe9v\xe9nement dans",
        days: "jours",
        hours: "heures",
        tomorrow: "Prochain \xe9v\xe9nement demain",
        today: "aujourd'hui"
    },
    search: {
        placeholder: "Rechercher un lieu...",
        submitLabel: "Rechercher",
        clearLabel: "Effacer la recherche",
        yourLocation: "Votre position"
    },
    filtering: {
        servicesTitle: "Filtrer",
        services: {
            AR: "Archery",
            ARG: "Artistic Gymnastics",
            ARS: "Artistic Swimming",
            ATH: "Athletics",
            BDM: "Badminton",
            BKB: "Basketball",
            BK3: "3x3 Basketball",
            BV: "Beach Volleyball",
            BOX: "Boxing",
            BKG: "Breaking",
            CSL: "Canoe Slalom",
            CSP: "Canoe Sprint",
            BMF: "Cycling BMX Freestyle",
            BMX: "Cycling BMX Racing",
            MTB: "Cycling Mountain Bike",
            CRD: "Cycling Road",
            CTR: "Cycling Track",
            DIV: "Diving",
            EQU: "Equestrian",
            FEN: "Fencing",
            FB: "Football",
            GLF: "Golf",
            HBL: "Handball",
            HOC: "Hockey",
            JUD: "Judo",
            OWS: "Marathon Swimming",
            MPN: "Modern Pentathlon",
            GRY: "Rhythmic Gymnastics",
            ROW: "Rowing",
            RU7: "Rugby Sevens",
            SAL: "Sailing",
            SHO: "Shooting",
            SKB: "Skateboarding",
            CLB: "Sport Climbing",
            SRF: "Surfing",
            SWM: "Swimming",
            TTE: "Table Tennis",
            TKW: "Taekwondo",
            TEN: "Tennis",
            GTR: "Trampoline Gymnastics",
            TRI: "Triathlon",
            VVO: "Volleyball",
            WPO: "Water Polo",
            WLF: "Weightlifting",
            WRE: "Wrestling"
        }
    },
    stores: {
        cta: {
            call: "Appeler",
            directions: "Itin\xe9raire",
            website: "Site Web"
        },
        messages: {
            initialHeader: "Chercher une localit\xe9 pour afficher les sites \xe0 proximit\xe9",
            emptyHeader: "Aucun r\xe9sultat retourn\xe9",
            initialBody: "ou s\xe9lectionner un site via la carte",
            emptyBody: "Rechercher ailleurs or d\xe9sactiver vos filtres"
        },
        types: {
            major: "Lieux de c\xe9l\xe9bration",
            minor: "Lieux visit\xe9"
        },
        name: {
            Stage: "Etape"
        }
    },
    directions: {
        avoidOptions: {
            highways: "Autoroutes",
            tolls: "P\xe9ages",
            ferries: "Transbordeurs"
        },
        avoidTransitOptions: {
            "train": "Train",
            "bus": "Bus",
            "ferries": "Transbordeurs",
            "aerial": "A\xe9rien"
        },
        unitOptions: {
            METRIC: "km",
            IMPERIAL: "milles"
        },
        options: "Options d'itin\xe9raire",
        avoid: "\xc9viter",
        units: "Unit\xe9s de distance",
        messages: {
            initialBody: "Renseigner une origine et une destination pour voir les itin\xe9raires disponible et le temps de trajet.",
            error: "D\xe9sol\xe9, impossible de calculer l'itin\xe9raire",
            from: "de",
            to: "\xe0",
            forTravelMode: "pour le mode de transport",
            via: "via",
            details: "Details",
            withoutTraffic: "sans circulation",
            openGoogleMaps: "ouvrir dans Google Maps",
            take: "Prendre",
            walk: "Marcher",
            the: "le"
        },
        transit: {
            "train": "train",
            "bus": "bus",
            "ferries": "transbordeurs",
            "aerial": "a\xe9rien",
            "tram": "tram",
            "rail": "train"
        }
    },
    errors: {
        loadingLibrary: "Impossible de charger le script {library}",
        geolocationFailed: "Impossible de g\xe9olocaliser l'utilisateur",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    },
    map: {
        showRoute: "Afficher l'itin\xe9raire"
    }
};



const $07470c5219c7337c$var$LOCALE_EN = "EN";
const $07470c5219c7337c$var$DEFAULT_LOCALE = $07470c5219c7337c$var$LOCALE_EN;
let $07470c5219c7337c$var$USER_LOCALE;
const $07470c5219c7337c$var$localeStorage = {};
const $07470c5219c7337c$export$9a2147b3808d4c6b = function() {
    return $07470c5219c7337c$var$DEFAULT_LOCALE;
}();
function $07470c5219c7337c$var$registerLocale(locale, localeObj) {
    locale = locale.toUpperCase();
    $07470c5219c7337c$var$localeStorage[locale] = localeObj;
}
function $07470c5219c7337c$export$ddc371781a6af754(lang, localeObj) {
    if (lang) {
        const localeObj = $07470c5219c7337c$var$localeStorage[lang.toUpperCase()] || {};
        if (lang === $07470c5219c7337c$var$LOCALE_EN) return {
            ...localeObj
        };
        else return (0, $fb6f3ecaa0346039$export$4950aa0f605343fb)({
            ...localeObj
        }, {
            ...$07470c5219c7337c$var$localeStorage[$07470c5219c7337c$var$DEFAULT_LOCALE]
        });
    } else return (0, $fb6f3ecaa0346039$export$4950aa0f605343fb)({
        ...localeObj
    }, {
        ...$07470c5219c7337c$var$localeStorage[$07470c5219c7337c$var$DEFAULT_LOCALE]
    });
}
function $07470c5219c7337c$export$e6103b0362967aab(lang) {
    if (lang) {
        $07470c5219c7337c$var$USER_LOCALE = lang;
        const userLocale = $07470c5219c7337c$export$ddc371781a6af754(lang);
        $07470c5219c7337c$var$registerLocale(lang, userLocale);
    }
}
function $07470c5219c7337c$export$180605366c04f0cd(lang) {
    if (lang) return $07470c5219c7337c$var$localeStorage[lang];
    else if ($07470c5219c7337c$var$USER_LOCALE) return $07470c5219c7337c$var$localeStorage[$07470c5219c7337c$var$USER_LOCALE];
    else return $07470c5219c7337c$var$localeStorage[$07470c5219c7337c$var$DEFAULT_LOCALE];
}
function $07470c5219c7337c$export$3814be8b8b1016be() {
    return $07470c5219c7337c$var$USER_LOCALE || $07470c5219c7337c$var$DEFAULT_LOCALE;
}
function $07470c5219c7337c$export$665560c9ff312dd4() {
    return (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
}
function $07470c5219c7337c$export$236350842f3cd9bc(localeObj, key) {
    if (localeObj[key] !== undefined && typeof localeObj[key] === "string") return localeObj[key];
    else return key;
}
$07470c5219c7337c$var$registerLocale($07470c5219c7337c$var$LOCALE_EN, (0, $24eea19f0baca79b$export$2e2bcd8739ae039));
$07470c5219c7337c$var$registerLocale("FR", (0, $42d54ebdf40f9ebe$export$2e2bcd8739ae039));


const $3599a15f761665e5$var$woosmapPublicKey = "woos-c1822d2f-e8ad-3603-859d-70d7afa385b4";
const $3599a15f761665e5$var$mobileBreakPoint = 768;
const $3599a15f761665e5$var$userLocationIconOptions = {
    url: "https://images.woosmap.com/user-position.png",
    scaledSize: {
        height: 32,
        width: 32
    }
};
const $3599a15f761665e5$var$mapPaddings = {
    mobile: {
        left: 50,
        right: 50,
        top: 100,
        bottom: 550
    },
    full: {
        left: 450,
        right: 50,
        top: 100,
        bottom: 50
    }
};
const $3599a15f761665e5$var$storesStyle = {
    breakPoint: 11,
    rules: [],
    default: {
        color: "#e61d2a",
        size: 11,
        minSize: 1,
        icon: {
            url: "https://woosmap-indoor-img.s3.amazonaws.com/lpernelle/JO_2024/venue.png",
            anchor: {
                x: 38,
                y: 76
            },
            size: {
                height: 512,
                width: 512
            },
            scaledSize: {
                height: 76,
                width: 76
            }
        },
        selectedIcon: {
            url: "https://woosmap-indoor-img.s3.amazonaws.com/lpernelle/JO_2024/venue.png",
            anchor: {
                x: 51,
                y: 98
            },
            size: {
                height: 512,
                width: 512
            },
            scaledSize: {
                height: 102,
                width: 102
            }
        }
    }
};
const $3599a15f761665e5$var$mapOptions = {
    center: {
        lat: 46.2,
        lng: 3.2
    },
    zoom: 6,
    styles: [
        {
            featureType: "point_of_interest",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        }
    ],
    gestureHandling: "greedy"
};
var $3599a15f761665e5$export$2e2bcd8739ae039 = {
    mapOptions: $3599a15f761665e5$var$mapOptions,
    storesStyle: $3599a15f761665e5$var$storesStyle,
    mapPaddings: $3599a15f761665e5$var$mapPaddings,
    mobileBreakPoint: $3599a15f761665e5$var$mobileBreakPoint,
    woosmapPublicKey: $3599a15f761665e5$var$woosmapPublicKey,
    userLocationIconOptions: $3599a15f761665e5$var$userLocationIconOptions
};


const $22a748251fc801b5$var$directionsOptions = {
    travelMode: "DRIVING",
    unitSystem: "METRIC",
    provideRouteAlternatives: true,
    avoid: []
};
const $22a748251fc801b5$var$distanceMatrixOptions = {
    travelMode: "DRIVING",
    unitSystem: "METRIC"
};
const $22a748251fc801b5$var$avoidOptions = [
    {
        paramKey: "highways"
    },
    {
        paramKey: "tolls"
    },
    {
        paramKey: "ferries"
    }
];
const $22a748251fc801b5$var$avoidTransitOptions = [
    {
        paramKey: "train"
    },
    {
        paramKey: "bus"
    },
    {
        paramKey: "ferries"
    },
    {
        paramKey: "aerial"
    }
];
const $22a748251fc801b5$var$unitOptions = [
    {
        paramKey: "METRIC"
    },
    {
        paramKey: "IMPERIAL"
    }
];
const $22a748251fc801b5$var$transitModes = {
    train: [
        "highSpeedTrain",
        "intercityTrain",
        "interRegionalTrain",
        "regionalTrain",
        "cityTrain",
        "subway",
        "lightRail",
        "monorail",
        "inclined"
    ],
    bus: [
        "bus",
        "privateBus",
        "busRapid"
    ],
    ferries: [
        "ferry"
    ],
    aerial: [
        "aerial",
        "flight",
        "spaceship"
    ]
};
const $22a748251fc801b5$var$travelModes = [
    {
        modeKey: "DRIVING",
        defaultIcon: "https://images.woosmap.com/directions/drive.png",
        selectedIcon: "https://images.woosmap.com/directions/drive_selected.png",
        darkIcon: "https://images.woosmap.com/directions/drive_black.png"
    },
    {
        modeKey: "TRANSIT",
        defaultIcon: "https://images.woosmap.com/directions/transit.png",
        selectedIcon: "https://images.woosmap.com/directions/transit_selected.png",
        darkIcon: "https://images.woosmap.com/directions/transit_black.png"
    },
    {
        modeKey: "WALKING",
        defaultIcon: "https://images.woosmap.com/directions/walk.png",
        selectedIcon: "https://images.woosmap.com/directions/walk_selected.png",
        darkIcon: "https://images.woosmap.com/directions/walk_black.png"
    },
    {
        modeKey: "CYCLING",
        defaultIcon: "https://images.woosmap.com/directions/bicycle.png",
        selectedIcon: "https://images.woosmap.com/directions/bicycle_selected.png",
        darkIcon: "https://images.woosmap.com/directions/bicycle_black.png"
    }
];
const $22a748251fc801b5$var$iconsDirections = {
    start: {
        url: "https://images.woosmap.com/directions/directions_start.png",
        scaledSize: {
            height: 14,
            width: 14
        }
    },
    end: {
        url: "https://images.woosmap.com/directions/directions_destination.png",
        scaledSize: {
            height: 16,
            width: 16
        }
    }
};
const $22a748251fc801b5$var$stepsIcon = [
    {
        index: 1,
        key: "Start",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 2,
        key: "StartRight",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 3,
        key: "StartLeft",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 4,
        key: "Destination",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 5,
        key: "DestinationRight",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 6,
        key: "DestinationLeft",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 8,
        key: "Continue",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 9,
        key: "SlightRight",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 10,
        key: "Right",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 11,
        key: "SharpRight",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 12,
        key: "UturnRight",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 13,
        key: "UturnLeft",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 14,
        key: "SharpLeft",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 15,
        key: "Left",
        icon: "https://images.woosmap.com/directions/turn_left_black.png"
    },
    {
        index: 16,
        key: "SlightLeft",
        icon: "https://images.woosmap.com/directions/turn_slight_left_black.png"
    },
    {
        index: 17,
        key: "RampStraight",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 18,
        key: "RampRight",
        icon: "https://images.woosmap.com/directions/merge_slight_left_black.png"
    },
    {
        index: 19,
        key: "RampLeft",
        icon: "https://images.woosmap.com/directions/merge_slight_left_black.png"
    },
    {
        index: 20,
        key: "ExitRight",
        icon: "https://images.woosmap.com/directions/merge_left_black.png"
    },
    {
        index: 21,
        key: "ExitLeft",
        icon: "https://images.woosmap.com/directions/merge_left_black.png"
    },
    {
        index: 22,
        key: "StayStraight",
        icon: "https://images.woosmap.com/directions/straight_black.png"
    },
    {
        index: 23,
        key: "StayRight",
        icon: "https://images.woosmap.com/directions/merge_slight_left_black.png"
    },
    {
        index: 24,
        key: "StayLeft",
        icon: "https://images.woosmap.com/directions/merge_slight_left_black.png"
    },
    {
        index: 25,
        key: "Merge",
        icon: "https://images.woosmap.com/directions/merge_black.png"
    },
    {
        index: 26,
        key: "RoundaboutEnter",
        icon: "https://images.woosmap.com/directions/roundabout_black.png"
    },
    {
        index: 27,
        key: "RoundaboutExit",
        icon: "https://images.woosmap.com/directions/roundabout_black.png"
    },
    {
        index: 28,
        key: "FerryEnter",
        icon: "https://images.woosmap.com/directions/boat_black.png"
    },
    {
        index: 29,
        key: "FerryExit",
        icon: "https://images.woosmap.com/directions/boat_black.png"
    },
    {
        index: 37,
        key: "MergeRight",
        icon: "https://images.woosmap.com/directions/merge_left_black.png"
    },
    {
        index: 38,
        key: "MergeLeft",
        icon: "https://images.woosmap.com/directions/merge_left_black.png"
    }
];
var $22a748251fc801b5$export$2e2bcd8739ae039 = {
    stepsIcon: $22a748251fc801b5$var$stepsIcon,
    iconsDirections: $22a748251fc801b5$var$iconsDirections,
    travelModes: $22a748251fc801b5$var$travelModes,
    unitOptions: $22a748251fc801b5$var$unitOptions,
    avoidOptions: $22a748251fc801b5$var$avoidOptions,
    avoidTransitOptions: $22a748251fc801b5$var$avoidTransitOptions,
    directionsOptions: $22a748251fc801b5$var$directionsOptions,
    distanceMatrixOptions: $22a748251fc801b5$var$distanceMatrixOptions,
    transitModes: $22a748251fc801b5$var$transitModes
};


const $9291b53d5e54f098$var$localitiesConf = {
    minLength: 0,
    data: "advanced",
    types: [
        "locality",
        "postal_code",
        "address",
        "admin_level",
        "airport",
        "train_station",
        "metro_station",
        "shopping",
        "country"
    ],
    components: {
        country: [
            "fr"
        ]
    }
};
const $9291b53d5e54f098$var$searchAPIParameters = {
    stores_by_page: 7,
    radius: 500000
};
const $9291b53d5e54f098$var$availableServices = [
    {
        category: "Sports",
        items: [
            {
                serviceKey: "AR"
            },
            {
                serviceKey: "ARG"
            },
            {
                serviceKey: "ARS"
            },
            {
                serviceKey: "ATH"
            },
            {
                serviceKey: "BDM"
            },
            {
                serviceKey: "BKB"
            },
            {
                serviceKey: "BK3"
            },
            {
                serviceKey: "BV"
            },
            {
                serviceKey: "BOX"
            },
            {
                serviceKey: "BKG"
            },
            {
                serviceKey: "CSP"
            },
            {
                serviceKey: "BMF"
            },
            {
                serviceKey: "BMX"
            },
            {
                serviceKey: "MTB"
            },
            {
                serviceKey: "CSL"
            },
            {
                serviceKey: "CRD"
            },
            {
                serviceKey: "CTR"
            },
            {
                serviceKey: "DIV"
            },
            {
                serviceKey: "EQU"
            },
            {
                serviceKey: "FEN"
            },
            {
                serviceKey: "FB"
            },
            {
                serviceKey: "GLF"
            },
            {
                serviceKey: "HBL"
            },
            {
                serviceKey: "HOC"
            },
            {
                serviceKey: "JUD"
            },
            {
                serviceKey: "OWS"
            },
            {
                serviceKey: "MPN"
            },
            {
                serviceKey: "GRY"
            },
            {
                serviceKey: "ROW"
            },
            {
                serviceKey: "RU7"
            },
            {
                serviceKey: "SAL"
            },
            {
                serviceKey: "SHO"
            },
            {
                serviceKey: "SKB"
            },
            {
                serviceKey: "CLB"
            },
            {
                serviceKey: "SRF"
            },
            {
                serviceKey: "SWM"
            },
            {
                serviceKey: "TTE"
            },
            {
                serviceKey: "TKW"
            },
            {
                serviceKey: "TEN"
            },
            {
                serviceKey: "GTR"
            },
            {
                serviceKey: "TRI"
            },
            {
                serviceKey: "VVO"
            },
            {
                serviceKey: "WPO"
            },
            {
                serviceKey: "WLF"
            },
            {
                serviceKey: "WRE"
            }
        ]
    }
];
var $9291b53d5e54f098$export$2e2bcd8739ae039 = {
    availableServices: $9291b53d5e54f098$var$availableServices,
    searchAPIParameters: $9291b53d5e54f098$var$searchAPIParameters,
    localitiesConf: $9291b53d5e54f098$var$localitiesConf
};


var $7f868f7298b680d4$var$selectors;
(function(selectors) {
    selectors["mapContainerID"] = "mapContainer";
    selectors["mapWrapperID"] = "mapWrapper";
    selectors["sidebarContainerID"] = "sidebarContainer";
    selectors["sidebarContentContainerID"] = "sidebarContentContainer";
    selectors["searchContainerID"] = "searchContainer";
    selectors["searchWrapperID"] = "searchWrapper";
    selectors["searchInputID"] = "searchInput";
    selectors["filterPanelContainerID"] = "filterPanelContainer";
    selectors["listStoresContainerID"] = "listStoresContainer";
    selectors["detailsStoreContainerID"] = "detailsStoreContainer";
    selectors["directionsContainerID"] = "directionsContainer";
    selectors["travelModeContainerID"] = "travelModeContainer";
    selectors["roadbookContainerID"] = "directionsInstructionsContainer";
    selectors["routeToggleContainerID"] = "routeToggleContainer";
    selectors["suggestionListID"] = "suggestionList";
})($7f868f7298b680d4$var$selectors || ($7f868f7298b680d4$var$selectors = {}));
var $7f868f7298b680d4$export$2e2bcd8739ae039 = $7f868f7298b680d4$var$selectors;


var $a7f488d82af6380b$var$urls;
(function(urls) {
    urls["baseApiUrl"] = "https://api.woosmap.com";
    urls["mapJS"] = "https://sdk.woosmap.com/map/map.js";
    urls["localitiesWidgetJS"] = "https://sdk.woosmap.com/localities/localitieswidget.2.0.js";
    urls["localitiesWidgetCSS"] = "https://sdk.woosmap.com/localities/style.2.0.css";
    urls["multiSearchJS"] = "https://sdk.woosmap.com/multisearch/multisearch.js";
})($a7f488d82af6380b$var$urls || ($a7f488d82af6380b$var$urls = {}));
var $a7f488d82af6380b$export$2e2bcd8739ae039 = $a7f488d82af6380b$var$urls;



const $9c65f6048f439acc$var$multiSearchConfig = {
    apiOrder: [
        "store",
        "localities"
    ],
    debounceTime: 100,
    localities: {
        key: "woos-c1822d2f-e8ad-3603-859d-70d7afa385b4",
        fallbackBreakpoint: 0.4,
        params: {
            components: {
                country: [
                    "fr"
                ]
            },
            language: "en",
            data: "advanced",
            types: [
                "locality",
                "postal_code",
                "address",
                "admin_level",
                "airport",
                "train_station",
                "metro_station",
                "shopping",
                "country"
            ]
        }
    },
    store: {
        key: "woos-c1822d2f-e8ad-3603-859d-70d7afa385b4",
        fallbackBreakpoint: false
    }
};
var $9c65f6048f439acc$export$2e2bcd8739ae039 = {
    multiSearchConfig: $9c65f6048f439acc$var$multiSearchConfig
};


const $376e204b4320ccbe$export$f84bd70098573c5c = {
    map: (0, $3599a15f761665e5$export$2e2bcd8739ae039),
    directions: (0, $22a748251fc801b5$export$2e2bcd8739ae039),
    search: (0, $9291b53d5e54f098$export$2e2bcd8739ae039),
    selectors: (0, $7f868f7298b680d4$export$2e2bcd8739ae039),
    urls: (0, $a7f488d82af6380b$export$2e2bcd8739ae039),
    multisearch: (0, $9c65f6048f439acc$export$2e2bcd8739ae039)
};
let $376e204b4320ccbe$var$currentConfig = $376e204b4320ccbe$export$f84bd70098573c5c;
function $376e204b4320ccbe$export$29b4b847eef7ae1e(configObj) {
    const config = configObj || {};
    return (0, $fb6f3ecaa0346039$export$4950aa0f605343fb)({
        ...config
    }, {
        ...$376e204b4320ccbe$var$currentConfig
    });
}
function $376e204b4320ccbe$export$940a7873bb071df8(configObj) {
    $376e204b4320ccbe$var$currentConfig = $376e204b4320ccbe$export$29b4b847eef7ae1e(configObj);
}
function $376e204b4320ccbe$export$44487a86467333c3() {
    return $376e204b4320ccbe$var$currentConfig;
}


var $70dedddd8cc8a209$export$715fed9478e7c158;
(function(MapComponentEvents) {
    MapComponentEvents["STORES_CHANGED"] = "stores_changed";
    MapComponentEvents["STORE_SELECTED"] = "store_selected";
    MapComponentEvents["STORE_UNSELECTED"] = "store_unselected";
    MapComponentEvents["FILTERS_UPDATED"] = "filters_updated";
    MapComponentEvents["MAP_READY"] = "map_ready";
    MapComponentEvents["MAP_IDLE"] = "map_idle";
    MapComponentEvents["LOCATION_CHANGED"] = "location_changed";
})($70dedddd8cc8a209$export$715fed9478e7c158 || ($70dedddd8cc8a209$export$715fed9478e7c158 = {}));
class $70dedddd8cc8a209$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.id = (0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.mapWrapperID;
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) (0, $5a3b137193fd24f6$export$2cb99e4be0dc4646)({
            url: (0, $376e204b4320ccbe$export$44487a86467333c3)().urls.mapJS,
            params: {
                key: this.state.woosmapPublicKey,
                language: (0, $07470c5219c7337c$export$3814be8b8b1016be)().toLowerCase()
            },
            override: true
        }).then(()=>{
            this.initMapView();
        }).catch((error)=>{
            console.error((0, $fb6f3ecaa0346039$export$77ad94ebf1c2b9ed)((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.loadingLibrary, {
                "library": "Woosmap Map JS SDK script"
            }), error);
        });
    }
    initMapView() {
        this.map = new woosmap.map.Map((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.mapWrapperID, this.state.mapOptions);
        this.styler = new (0, $30562ad46da16b22$export$2e2bcd8739ae039)(this.state.storesStyle);
        this.storesOverlay = new woosmap.map.StoresOverlay(this.state.storesStyle);
        this.storesOverlay.setMap(this.map);
        this.data = new woosmap.map.Data();
        this.data.setMap(this.map);
        this.data.addListener("click", (data)=>{
            const feature = data.feature;
            feature.toGeoJson((geojson)=>{
                this.handleSelectedStore(geojson);
            });
        });
        this.data.setStyle((feature)=>{
            return this.styler.getStyledIcon({
                types: feature.properties.types
            });
        });
        if (this.state.location) {
            this.map.setCenter({
                lat: this.state.location.latitude,
                lng: this.state.location.longitude
            });
            this.map.setZoom(this.state.location.zoom);
        } else {
            const center = (0, $376e204b4320ccbe$export$44487a86467333c3)().map.mapOptions.center || {
                lat: 46.2,
                lng: 3.2
            };
            this.map.setCenter(center, this.state.padding);
        }
        // No style option allows to put a data feature on top of the others (zIndex StyleOptions not implemented yet)
        // Create a second data Layer to handle the selected Store.
        this.dataSelected = new woosmap.map.Data();
        this.dataSelected.setMap(this.map);
        this.dataSelected.setStyle((feature)=>{
            return this.styler.getStyledIcon({
                types: feature.properties.types,
                selected: true
            });
        });
        woosmap.map.event.addListener(this.map, "store_selected", (store)=>{
            this.handleSelectedStore(store);
        });
        woosmap.map.event.addListenerOnce(this.map, "idle", ()=>{
            this.emit("map_idle");
        });
        this.map.addListener("center_changed", (0, $fb6f3ecaa0346039$export$61fc7d43ac8f84b0)(()=>{
            this.handleLocationChanged();
        }, 150));
        this.on("stores_changed", ()=>{
            this.handleStores();
        });
        this.on("store_selected", ()=>{
            this.selectStore();
        });
        this.on("store_unselected", ()=>{
            this.selectStore();
        });
        this.on("filters_updated", ()=>{
            this.updateFilters();
        });
        this.emit("map_ready");
    }
    handleSelectedStore(store) {
        this.setState({
            selectedStore: store
        }, true, ()=>{
            this.emit("store_selected", this.state.selectedStore);
        });
    }
    handleLocationChanged() {
        this.setState({
            location: {
                zoom: this.map.getZoom(),
                latitude: this.map.getCenter().lat(),
                longitude: this.map.getCenter().lng()
            }
        }, true, ()=>{
            this.emit("location_changed", this.state.location);
        });
    }
    handleStores() {
        if (this.state.stores) {
            if (this.state.stores.length > 0) {
                this.data.setMap(this.map);
                this.data.forEach((feature)=>this.data.remove(feature));
                this.dataSelected.forEach((feature)=>this.dataSelected.remove(feature));
                //create a deepCopy instead of shallowCopy to avoid modifying this.state.stores
                const features = JSON.parse(JSON.stringify(this.state.stores));
                this.data.addGeoJson({
                    type: "FeatureCollection",
                    features: features
                }, {
                    idPropertyName: "store_id"
                });
                const bounds = new woosmap.map.LatLngBounds();
                this.data.forEach((feature)=>{
                    const LatLngPoint = feature.getGeometry();
                    bounds.extend(LatLngPoint.get());
                });
                if (this.state.nearbyLocation) bounds.extend(this.state.nearbyLocation);
                if (!this.state.nearbyLocation) {
                    if (this.state.stores.length === 1) {
                        const feature = this.state.stores[0];
                        const storeLocation = feature.geometry.coordinates;
                        this.map.flyTo({
                            center: {
                                lat: storeLocation[1],
                                lng: storeLocation[0]
                            },
                            zoom: 12,
                            padding: this.state.padding,
                            animate: true
                        });
                    } else this.map.fitBounds(bounds, this.state.padding);
                } else // The user location & the nearest stores should be in viewport
                this.map.fitBounds(bounds, this.state.padding, true);
                // this.map.fitBounds(bounds, this.state.padding);
                this.storesOverlay.setMap(null);
            } else {
                this.storesOverlay.setMap(this.map);
                this.data.setMap(null);
                this.dataSelected.setMap(null);
            }
        }
    }
    unselectStoreOnDataOverlay() {
        this.data.revertStyle();
        this.dataSelected.forEach((feature)=>this.dataSelected.remove(feature));
    }
    selectStoreOnDataOverlay(store) {
        const selectedStore = store ? JSON.parse(JSON.stringify(store)) : JSON.parse(JSON.stringify(this.state.selectedStore));
        let feature = null;
        if (this.data) feature = this.data.getFeatureById(selectedStore.properties.store_id);
        if (feature) {
            this.data.revertStyle();
            this.data.overrideStyle(feature, {
                visible: false
            });
            this.dataSelected.forEach((feature)=>this.dataSelected.remove(feature));
            this.dataSelected.add(feature);
            this.dataSelected.setMap(this.map);
        } else this.storesOverlay.setSelection(selectedStore);
    }
    selectStore() {
        if (this.state.selectedStore) {
            this.selectStoreOnDataOverlay();
            const visibleBounds = this.map.getBounds(this.state.padding);
            const selectedStore = this.state.selectedStore;
            const latLng = {
                lng: selectedStore.geometry.coordinates[0],
                lat: selectedStore.geometry.coordinates[1]
            };
            if (latLng) {
                if (!visibleBounds.contains(latLng)) this.map.panTo(latLng, this.state.padding);
            }
        } else {
            this.storesOverlay.clearSelection();
            this.data.revertStyle();
            this.handleStores();
        }
    }
    updateFilters() {
        if (this.state.query) {
            this.storesOverlay.setQuery(this.state.query);
            this.handleStores();
        } else this.storesOverlay.setQuery(undefined);
    }
}






var $a9c37de1965973a2$export$862abd191a2ee43;
(function(GeolocationError) {
    GeolocationError["Unavailable"] = "Unavailable";
    GeolocationError["PermissionDenied"] = "PermissionDenied";
    GeolocationError["PositionUnavailable"] = "PositionUnavailable";
    GeolocationError["Timeout"] = "Timeout";
    GeolocationError["Default"] = "Default";
})($a9c37de1965973a2$export$862abd191a2ee43 || ($a9c37de1965973a2$export$862abd191a2ee43 = {}));
class $a9c37de1965973a2$export$68d023cdc03da2f1 {
    static async getCurrentPosition() {
        try {
            return await new Promise((resolve, reject)=>{
                $a9c37de1965973a2$export$68d023cdc03da2f1.getNavigatorGeolocation().getCurrentPosition(resolve, reject, $a9c37de1965973a2$export$68d023cdc03da2f1.GeolocationOptions);
            });
        } catch (error) {
            throw new Error($a9c37de1965973a2$export$68d023cdc03da2f1.getGeolocationError(error));
        }
    }
    static getNavigatorGeolocation() {
        if (!navigator.geolocation) throw new Error("Unavailable");
        return navigator.geolocation;
    }
    static isGeolocationError(error) {
        return typeof error === "object" && "PERMISSION_DENIED" in error;
    }
    static getGeolocationError(error) {
        console.error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.geolocationFailed, error);
        if ($a9c37de1965973a2$export$68d023cdc03da2f1.isGeolocationError(error)) switch(error.code){
            case error.PERMISSION_DENIED:
                return "PermissionDenied";
            case error.POSITION_UNAVAILABLE:
                return "PositionUnavailable";
            case error.TIMEOUT:
                return "Timeout";
            default:
                return "Default";
        }
        else if (error.message === "Unavailable") return "Unavailable";
        else return "Default";
    }
}
$a9c37de1965973a2$export$68d023cdc03da2f1.GeolocationOptions = {
    enableHighAccuracy: true,
    timeout: 6000,
    maximumAge: 30000
};



var $f6cc29bbdc6ec6b8$export$d34e68953e15144d;
(function(GeolocateComponentEvents) {
    GeolocateComponentEvents["GEOLOCATION_FOUND"] = "geolocation_found";
    GeolocateComponentEvents["GEOLOCATION_ERROR"] = "geolocation_error";
})($f6cc29bbdc6ec6b8$export$d34e68953e15144d || ($f6cc29bbdc6ec6b8$export$d34e68953e15144d = {}));
class $f6cc29bbdc6ec6b8$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
    }
    render() {
        if (this.state && this.$element) {
            this.$element.className = "search__geolocateBtn";
            this.$element.innerHTML = `<button type="button" aria-label="${(0, $07470c5219c7337c$export$180605366c04f0cd)().search.yourLocation}"></button>`;
            this.$element.addEventListener("click", async ()=>{
                this.$element.classList.add("active");
                await this.getLocation().then(()=>{
                    this.$element.classList.remove("active");
                });
            });
            this.$target.appendChild(this.$element);
        }
    }
    setPosition(geoPosition) {
        const { latitude: latitude, longitude: longitude, altitude: altitude, accuracy: accuracy } = geoPosition.coords;
        this.setState({
            position: {
                name: (0, $07470c5219c7337c$export$180605366c04f0cd)().search.yourLocation,
                timestamp: Date.now(),
                latitude: latitude,
                longitude: longitude,
                altitude: altitude,
                accuracy: accuracy
            }
        }, true, ()=>{
            this.emit("geolocation_found", this.state.position);
        });
    }
    async getLocation() {
        try {
            const position = await (0, $a9c37de1965973a2$export$68d023cdc03da2f1).getCurrentPosition();
            this.setPosition(position);
        } catch (error) {
            this.onGeolocationError(error);
        }
    }
    onGeolocationError(error) {
        this.setState({
            error: error,
            position: undefined
        }, true, ()=>{
            this.emit("geolocation_error");
        });
    }
}


/**
 * Previously loading/loaded css stylesheets that have been requested by `loadCss()`.
 */ let $122d1d51993fbc5f$var$cachedCss = {};
function $122d1d51993fbc5f$export$82219ea58a717c3f(href) {
    const existing = $122d1d51993fbc5f$var$cachedCss[href];
    if (existing) return existing;
    const promise = new Promise((resolve, reject)=>{
        if ($122d1d51993fbc5f$var$findCss(href)) resolve();
        const css = $122d1d51993fbc5f$var$createLinkElement(href);
        const onCssLoad = ()=>{
            resolve();
        };
        const onCssError = ()=>{
            cleanup();
            delete $122d1d51993fbc5f$var$cachedCss[href];
            css.remove();
            const defaultError = new Error(`The css "${href}" failed to load.`);
            reject(defaultError);
        };
        css.addEventListener("load", onCssLoad);
        css.addEventListener("error", onCssError);
        document.head.insertBefore(css, document.head.firstElementChild);
        function cleanup() {
            css.removeEventListener("load", onCssLoad);
            css.removeEventListener("error", onCssError);
        }
    });
    $122d1d51993fbc5f$var$cachedCss[href] = promise;
    return promise;
}
/**
 * Find css href in the DOM
 * @param {string} href - used to set the css href.
 * @return {boolean | null} returns `true` if css link exist otherwise `null`.
 */ function $122d1d51993fbc5f$var$findCss(href) {
    const currentCss = document.querySelector(`link[href="${href}"]`);
    if (currentCss === null) return null;
    return true;
}
/**
 * Creates Link Element
 * @param {string} href - the css href
 * @return {HTMLScriptElement} returns the newly created script.
 */ function $122d1d51993fbc5f$var$createLinkElement(href) {
    const newLink = document.createElement("link");
    newLink.rel = "stylesheet";
    newLink.type = "text/css";
    newLink.href = href;
    return newLink;
}
function $122d1d51993fbc5f$export$a19643d5acb30753() {
    $122d1d51993fbc5f$var$cachedCss = {};
}





var $20c9addaea1cd938$export$bec4f8eff0df0668;
(function(SearchComponentEvents) {
    SearchComponentEvents["SELECTED_LOCALITY"] = "selected_locality";
    SearchComponentEvents["SEARCH_CLEAR"] = "search_clear";
})($20c9addaea1cd938$export$bec4f8eff0df0668 || ($20c9addaea1cd938$export$bec4f8eff0df0668 = {}));
class $20c9addaea1cd938$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("input");
        this.$element.className = "search__input";
        this.$element.setAttribute("placeholder", (0, $07470c5219c7337c$export$180605366c04f0cd)().search.placeholder);
        this.$element.setAttribute("aria-label", (0, $07470c5219c7337c$export$180605366c04f0cd)().search.placeholder);
        this.$element.setAttribute("aria-autocomplete", "list");
        this.$element.setAttribute("autocomplete", "off");
        this.$element.id = this.state.inputID;
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) (0, $5a3b137193fd24f6$export$2cb99e4be0dc4646)({
            url: (0, $376e204b4320ccbe$export$44487a86467333c3)().urls.localitiesWidgetJS,
            params: {
                key: this.state.woosmapPublicKey
            }
        }).then(()=>(0, $122d1d51993fbc5f$export$82219ea58a717c3f)((0, $376e204b4320ccbe$export$44487a86467333c3)().urls.localitiesWidgetCSS)).then(()=>this.initSearchView()).catch((error)=>{
            console.error((0, $fb6f3ecaa0346039$export$77ad94ebf1c2b9ed)((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.loadingLibrary, {
                "library": "Woosmap Localities JS Widget"
            }), error);
        });
    }
    initSearchView() {
        const searchOptions = (0, $fb6f3ecaa0346039$export$4950aa0f605343fb)({
            ...this.state.searchOptions
        }, {
            language: (0, $07470c5219c7337c$export$3814be8b8b1016be)().toLowerCase()
        });
        this.localitiesWidget = new woosmap.localities.Autocomplete(this.state.inputID, searchOptions);
        this.localitiesWidget.addListener("selected_suggestion", ()=>{
            const locality = this.localitiesWidget.getSelectedSuggestionDetails();
            const searchLocation = {
                name: locality.formatted_address || locality.name,
                publicId: locality.public_id,
                location: locality.geometry.location
            };
            this.setState({
                selectedLocality: searchLocation
            }, true);
            this.emit("selected_locality", searchLocation);
        });
        const $inputContainer = document.getElementById(this.state.inputID).parentElement;
        this.state.featuresBtn.forEach((feature)=>{
            if (feature === "search") this.manageSearchButton($inputContainer);
            if (feature === "clear") this.manageClearButton($inputContainer);
            if (feature === "geolocate") this.manageGeolocateButton($inputContainer);
        });
        this.selectLocality();
    }
    selectLocality() {
        if (this.state.selectedLocality) {
            this.setLocality(this.state.selectedLocality.name || "");
            this.emit("selected_locality", this.state.selectedLocality);
        }
    }
    manageSearchButton($inputContainer) {
        const $searchBtn = document.createElement("div");
        $searchBtn.className = "search__searchBtn";
        $searchBtn.innerHTML = `<button type="button" aria-label="${(0, $07470c5219c7337c$export$180605366c04f0cd)().search.submitLabel}"></button>`;
        $searchBtn.addEventListener("click", ()=>{
            if (this.state.selectedLocality) this.emit("selected_locality", this.state.selectedLocality);
            else this.$element.focus();
        });
        $inputContainer.appendChild($searchBtn);
    }
    manageClearButton($inputContainer) {
        const $clearBtn = document.createElement("div");
        $clearBtn.className = "search__clearBtn";
        $clearBtn.innerHTML = `<button type="button" aria-label="${(0, $07470c5219c7337c$export$180605366c04f0cd)().search.clearLabel}"></button>`;
        $clearBtn.addEventListener("click", ()=>this.handleClearBtnClick($clearBtn, $inputContainer));
        [
            "input",
            "locality_changed"
        ].forEach((evt)=>this.$element.addEventListener(evt, ()=>this.handleInputChange($clearBtn)));
        $clearBtn.style.display = "none";
        $inputContainer.appendChild($clearBtn);
    }
    // setLocality(name: string): void {
    //     if (this.$element && this.$element instanceof HTMLInputElement && this.$target.querySelector(".search__clearBtn")) {
    //         const modifiedName = name.replace('Stage', getLocale().stores.name.Stage);
    //         (this.$element as HTMLInputElement).value = modifiedName;
    //         (this.$element as HTMLInputElement).dispatchEvent(new Event('locality_changed'));
    //     }
    //     // const observer = new MutationObserver((mutationsList, observer) => {
    //     //         console.log('Mutation ', observer);
    //     //         if (this.$element && this.$element instanceof HTMLInputElement && this.$target.querySelector(".search__clearBtn")) {
    //     //             (this.$element as HTMLInputElement).value = name;
    //     //             (this.$element as HTMLInputElement).dispatchEvent(new Event('locality_changed'));
    //     //             observer.disconnect();
    //     //         }
    //     //     }
    //     // );
    //     // observer.observe(document, {childList: true, subtree: true});
    // }
    setLocality(name) {
        this.$element.value = name;
        this.$element.dispatchEvent(new Event("locality_changed"));
    }
    manageGeolocateButton($inputContainer) {
        const geolocateComponent = new (0, $f6cc29bbdc6ec6b8$export$2e2bcd8739ae039)({
            $target: $inputContainer,
            initialState: {}
        });
        geolocateComponent.on((0, $f6cc29bbdc6ec6b8$export$d34e68953e15144d).GEOLOCATION_FOUND, (geolocation)=>{
            if (geolocation) {
                const searchLocation = {
                    name: geolocation.name,
                    location: {
                        lat: geolocation.latitude,
                        lng: geolocation.longitude
                    }
                };
                this.setLocality((0, $07470c5219c7337c$export$180605366c04f0cd)().search.yourLocation);
                this.setState({
                    selectedLocality: searchLocation
                }, true);
                this.emit("selected_locality", searchLocation);
            }
        });
    }
    getLocality() {
        if (this.state) return this.state.selectedLocality;
    }
    constructor(...args){
        super(...args);
        this.handleClearBtnClick = ($clearBtn, $inputContainer)=>{
            const $emptyButton = $inputContainer.querySelector(".localities-empty-button");
            if ($emptyButton) {
                $emptyButton.click();
                $clearBtn.style.display = "none";
            } else {
                this.$element.value = "";
                $clearBtn.style.display = "none";
                this.$element.focus();
            }
            this.emit("search_clear");
        };
        this.handleInputChange = ($clearBtn)=>{
            if (this.$element.value.length === 0) $clearBtn.style.display = "none";
            else $clearBtn.style.display = "block";
        };
    }
}





function $436938c94ed6ad8c$export$a4b8ee4ccc3b7327(address) {
    if (!address) return "";
    const readableAddress = [];
    if (typeof (address === null || address === void 0 ? void 0 : address.lines) === "string") readableAddress.push(address === null || address === void 0 ? void 0 : address.lines);
    // if (typeof address.lines !== "undefined" && address.lines !== null && typeof address?.lines !== 'string' && address.lines.length >= 0) {
    //     readableAddress.push(...address.lines);
    // }
    if (address.zipcode) readableAddress.push(address.zipcode);
    if (address.city) readableAddress.push(address.city);
    return readableAddress.join(", ");
}
function $436938c94ed6ad8c$export$5f1d97f53c43eb95(distance, unitSystem = "metric") {
    if (!distance) return "";
    let readableDistance;
    const meterToYard = 1.09361;
    const unitSystemValues = {
        metric: {
            unit: "km",
            smallUnit: "m",
            factor: 1000
        },
        imperial: {
            unit: "mi",
            smallUnit: "yd",
            factor: 1760
        }
    };
    const system = unitSystemValues["metric"];
    if (unitSystem === "imperial") distance *= meterToYard;
    if (distance < system.factor) readableDistance = Math.round(distance) + "\xa0" + system.smallUnit;
    else readableDistance = parseFloat((distance / system.factor).toFixed(1)) + "\xa0" + system.unit;
    return readableDistance;
}
function $436938c94ed6ad8c$export$adee39cd77054230(contact) {
    if (!contact || !contact.phone) return "";
    const $contactLink = document.createElement("a");
    $contactLink.className = "contactPhone";
    $contactLink.href = `tel:${contact.phone}`;
    $contactLink.text = contact.phone;
    return $contactLink.outerHTML;
}
function $436938c94ed6ad8c$export$480cc82b47a34531(contact) {
    if (!contact || !contact.website) return "";
    const $websiteLink = document.createElement("a");
    $websiteLink.className = "contactWebsite";
    $websiteLink.href = `${contact.website}`;
    $websiteLink.target = `_blank`;
    $websiteLink.text = (0, $07470c5219c7337c$export$180605366c04f0cd)().stores.cta.website;
    return $websiteLink.outerHTML;
}
function $436938c94ed6ad8c$export$474367fb1a91710b(servicesList) {
    const storeServices = servicesList.map((service)=>(0, $376e204b4320ccbe$export$44487a86467333c3)().search.availableServices.filter(({ serviceKey: serviceKey })=>serviceKey === service)[0]).filter((x)=>x);
    const $storeServices = document.createElement("ul");
    $storeServices.className = "detailsStore__services";
    const servicesHTML = storeServices.map((service)=>{
        const $service = document.createElement("li");
        $service.dataset.servicekey = service.serviceKey;
        $service.dataset.servicename = (0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().filtering.services, service.serviceKey);
        $service.innerHTML = `
        <div class='iconService iconService__${service.serviceKey}'></div>
        <div class='serviceName'>${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().filtering.services, service.serviceKey)}</div>`;
        return $service;
    });
    $storeServices.append(...servicesHTML);
    return $storeServices.outerHTML;
}
function $436938c94ed6ad8c$export$a1781a8729551ae5(store) {
    let openLabel = "";
    function _convertTime(UNIX_timestamp) {
        const a = new Date(UNIX_timestamp * 1000);
        return a.toLocaleString((0, $07470c5219c7337c$export$3814be8b8b1016be)(), {
            weekday: "long",
            day: "numeric",
            month: "short"
        });
    }
    try {
        var _store_open, _store_open1;
        if ((_store_open = store.open) === null || _store_open === void 0 ? void 0 : _store_open.open_now) {
            openLabel = `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.openUntil} ${store.open.current_slice.end}`;
            if (store.weekly_opening) {
                if (store.open.current_slice.end) openLabel = `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.openUntil} ${store.open.current_slice.end}`;
                else if (store.open.current_slice["all-day"]) openLabel = (0, $07470c5219c7337c$export$180605366c04f0cd)().time.open24_7;
            } else {
                if (store.open.current_slice.end) openLabel = `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.openUntil} ${store.open.current_slice.end}`;
                else if (store.open.current_slice["all-day"]) openLabel = (0, $07470c5219c7337c$export$180605366c04f0cd)().time.open24_7;
            }
        } else if ((_store_open1 = store.open) === null || _store_open1 === void 0 ? void 0 : _store_open1.next_opening) {
            var _store_open2;
            if ($436938c94ed6ad8c$var$isToday(new Date((_store_open2 = store.open) === null || _store_open2 === void 0 ? void 0 : _store_open2.next_opening.day))) openLabel += openLabel += `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.opensToday} ${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.at} ${store.open.next_opening.start}`;
            else openLabel += `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.opens} ${_convertTime(Date.parse(store.open.next_opening.day) / 1000)} ${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.at} ${store.open.next_opening.start}`;
        } else openLabel = `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.closed}`;
        return openLabel;
    } catch (error) {
        return "";
    }
}
function $436938c94ed6ad8c$export$68d7463414e9d987(weeklyOpening) {
    const readableOpeningHours = {
        "1": {
            dayName: (0, $07470c5219c7337c$export$180605366c04f0cd)().time.dayOfWeek[0],
            hoursDay: ""
        },
        "2": {
            dayName: (0, $07470c5219c7337c$export$180605366c04f0cd)().time.dayOfWeek[1],
            hoursDay: ""
        },
        "3": {
            dayName: (0, $07470c5219c7337c$export$180605366c04f0cd)().time.dayOfWeek[2],
            hoursDay: ""
        },
        "4": {
            dayName: (0, $07470c5219c7337c$export$180605366c04f0cd)().time.dayOfWeek[3],
            hoursDay: ""
        },
        "5": {
            dayName: (0, $07470c5219c7337c$export$180605366c04f0cd)().time.dayOfWeek[4],
            hoursDay: ""
        },
        "6": {
            dayName: (0, $07470c5219c7337c$export$180605366c04f0cd)().time.dayOfWeek[5],
            hoursDay: ""
        },
        "7": {
            dayName: (0, $07470c5219c7337c$export$180605366c04f0cd)().time.dayOfWeek[0],
            hoursDay: ""
        }
    };
    const $storeOpeningWeek = document.createElement("ul");
    $storeOpeningWeek.className = "storeDetails__openingWeek";
    const today = new Date().toLocaleString((0, $07470c5219c7337c$export$3814be8b8b1016be)(), {
        weekday: "long"
    });
    Object.entries(weeklyOpening).forEach(([day, hoursPeriod])=>{
        if (!hoursPeriod || hoursPeriod.length === 0) readableOpeningHours[day].hoursDay = (0, $07470c5219c7337c$export$180605366c04f0cd)().time.closed;
        else if (readableOpeningHours[day]) {
            var _hoursPeriod_hours;
            if (readableOpeningHours[day].dayName === today) readableOpeningHours[day].today = true;
            if (((_hoursPeriod_hours = hoursPeriod.hours) === null || _hoursPeriod_hours === void 0 ? void 0 : _hoursPeriod_hours.length) === 0) readableOpeningHours[day].hoursDay = (0, $07470c5219c7337c$export$180605366c04f0cd)().time.closed;
            else readableOpeningHours[day].hoursDay = $436938c94ed6ad8c$var$concatenateStoreHours(hoursPeriod.hours);
        }
    });
    const hoursHTML = Object.entries(readableOpeningHours).map(([dayIndex, dayValues])=>{
        const $listDay = document.createElement("li");
        $listDay.className = dayValues.today ? "currentDay" : "";
        $listDay.innerHTML = `<span class='day ${dayIndex}'>${dayValues.dayName}</span><span class='hours'>${dayValues.hoursDay}</span>`;
        return $listDay;
    });
    $storeOpeningWeek.append(...hoursHTML);
    return $storeOpeningWeek.outerHTML;
}
function $436938c94ed6ad8c$var$isToday(date) {
    const today = new Date();
    return today.toDateString() === date.toDateString();
}
function $436938c94ed6ad8c$var$concatenateStoreHours(openHours) {
    const hoursText = [];
    let end = "";
    openHours.forEach((period)=>{
        if ("all-day" in period || period.end === "00:00" && period.start === "00:00") return "24h/24";
        end = period.end;
        hoursText.push(`${period.start}\u{2013}${end}`);
    });
    return hoursText.join(", ");
}
function $436938c94ed6ad8c$export$3ae94a2503e890a1(inputDate) {
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const [year, month, day] = inputDate.split("-");
    const monthIndex = parseInt(month) - 1; // Adjust month index since months are zero-indexed
    return `${months[monthIndex]} ${parseInt(day)}, ${year}`;
}
function $436938c94ed6ad8c$export$3d1fa75de54ffd7a(inputDate) {
    // const [year, month, day] = inputDate.split('-').map(Number);
    const monthMap = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11
    };
    const [dayOfWeek, day, month, year, time] = inputDate.split(" ");
    // Créer une nouvelle instance de Date
    const date = new Date(Number(year), monthMap[month], Number(day));
    // Obtenir le nom du jour de la semaine (en français)
    const formatter = new Intl.DateTimeFormat((0, $07470c5219c7337c$export$3814be8b8b1016be)(), {
        weekday: "long",
        month: "long",
        day: "numeric"
    });
    return formatter.format(date);
}
function $436938c94ed6ad8c$export$1b7939870a25829d(inputDate) {
    const today = new Date();
    const targetDate = new Date(inputDate);
    if (isNaN(targetDate.getTime())) return "Invalid date format";
    const diffInMillis = targetDate.getTime() - today.getTime();
    const diffInDays = Math.floor(diffInMillis / 86400000);
    if (diffInDays === 0) {
        const diffInHours = Math.floor(diffInMillis / 3600000);
        const diffInMinutes = Math.floor(diffInMillis % 3600000 / 60000);
        return `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.eventCountdown} ${diffInHours} ${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.hours} and ${diffInMinutes} minutes`;
    } else if (diffInDays === 1) return `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.tomorrow}`;
    else if (diffInDays < 0) return ``;
    return `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.eventCountdown} ${diffInDays} ${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.days}`;
}
function $436938c94ed6ad8c$export$1c2b6984022f3a11(inputDate) {
    const today = new Date();
    const targetDate = new Date(inputDate);
    if (isNaN(targetDate.getTime())) return "Invalid date format";
    const diffInMillis = targetDate.getTime() - today.getTime();
    // const diffInDays = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));
    const days = Math.floor(diffInMillis / 86400000);
    const diffInDays = days + (days !== 0 ? 1 : 0);
    if (diffInDays === 0) {
        const diffInHours = Math.floor(diffInMillis / 3600000);
        const diffInMinutes = Math.floor(diffInMillis % 3600000 / 60000);
        if (diffInHours === 0) return `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.eventCountdown} ${diffInMinutes} minutes`;
        else return `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.eventCountdown} ${diffInHours} ${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.hours} and ${diffInMinutes} minutes`;
    } else if (diffInDays <= 1) return diffInDays === 0 ? `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.today}` : `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.tomorrow}`;
    else if (diffInDays < 0) return ``;
    return `${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.eventCountdown} ${diffInDays} ${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.days}`;
}



var $3e361f38741262ad$export$fc087719351cdb12;
(function(StoreDetailsComponentEvents) {
    StoreDetailsComponentEvents["DIRECTIONS_SHOW"] = "directions_show";
    StoreDetailsComponentEvents["BACK"] = "back";
})($3e361f38741262ad$export$fc087719351cdb12 || ($3e361f38741262ad$export$fc087719351cdb12 = {}));
class $3e361f38741262ad$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            if (this.state.store) {
                var _properties_tags, _properties_user_properties;
                const properties = this.state.store.properties;
                const htmlElements = [];
                const $backBtn = this.getBackButton();
                const $storeDetailsHeader = this.getDetailsHeader(properties);
                const $storeDetailsActions = this.getActionsButtons(properties);
                const $eventDetails = this.getEvents(properties);
                const $storeDetails = document.createElement("div");
                $storeDetails.className = "detailsStore";
                $storeDetails.innerHTML = `
                             ${properties.weekly_opening ? `<div class="detailsStore__content detailsStore__listItems"><div class="detailsStore__headerList">${(0, $07470c5219c7337c$export$180605366c04f0cd)().time.openingHoursTitle}</div>${(0, $436938c94ed6ad8c$export$68d7463414e9d987)(properties.weekly_opening)}</div>` : ""}
                             ${((_properties_tags = properties.tags) === null || _properties_tags === void 0 ? void 0 : _properties_tags.length) ? `<div class="detailsStore__content detailsStore__listItems"><div class="detailsStore__headerList">${(0, $07470c5219c7337c$export$180605366c04f0cd)().filtering.servicesTitle}</div>${(0, $436938c94ed6ad8c$export$474367fb1a91710b)(properties.tags)}</div>` : ""}`;
                htmlElements.push($backBtn, $storeDetailsHeader, $storeDetailsActions, $eventDetails);
                this.$target.replaceChildren(...htmlElements);
                this.updateEventCountdown((_properties_user_properties = properties.user_properties) === null || _properties_user_properties === void 0 ? void 0 : _properties_user_properties.events);
            }
        }
    }
    getDetailsHeader(properties) {
        var _properties_types, _properties_user_properties, _properties_types1, _properties_user_properties1;
        const $storeDetailsHeader = document.createElement("div");
        const typeOfSite = ((_properties_types = properties.types) === null || _properties_types === void 0 ? void 0 : _properties_types.length) ? properties.types.join(" ,") : "";
        const name = properties.name.replace("Stage", (0, $07470c5219c7337c$export$180605366c04f0cd)().stores.name.Stage);
        $storeDetailsHeader.className = "detailsStore";
        $storeDetailsHeader.innerHTML = `
                             <div class="detailsStore__thumbnail"><div class="detailsStore__thumbnailImg" style="background-image: url(${(_properties_user_properties = properties.user_properties) === null || _properties_user_properties === void 0 ? void 0 : _properties_user_properties.imageURL})"></div></div>
                             <div class="detailsStore__content detailsStore__name">${name}</div>
                             ${((_properties_types1 = properties.types) === null || _properties_types1 === void 0 ? void 0 : _properties_types1.length) ? `<div class="detailsStore__content detailsStore__types">${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().stores.types, typeOfSite)}</div>` : ""}                             
                             ${properties.address ? `<div class="detailsStore__content detailsStore__address">${(0, $436938c94ed6ad8c$export$a4b8ee4ccc3b7327)(properties.address)}</div>` : ""}
                             ${((_properties_user_properties1 = properties.user_properties) === null || _properties_user_properties1 === void 0 ? void 0 : _properties_user_properties1.events) ? `<div class="detailsStore__content detailsStore__event">Next event in</div>` : ""}`;
        return $storeDetailsHeader;
    }
    getActionsButtons(properties) {
        var _properties_contact, _properties_contact1;
        const $storeDetailsActions = document.createElement("div");
        $storeDetailsActions.className = "detailsStore__content detailsStore__actions";
        const $directionsBtn = document.createElement("button");
        $directionsBtn.className = "button";
        $directionsBtn.addEventListener("click", ()=>this.emit("directions_show", this.state.store));
        $directionsBtn.innerHTML = `<div class="buttonIcon directionsButton"></div><span>${(0, $07470c5219c7337c$export$180605366c04f0cd)().stores.cta.directions}</span>`;
        $storeDetailsActions.appendChild($directionsBtn);
        if ((_properties_contact = properties.contact) === null || _properties_contact === void 0 ? void 0 : _properties_contact.phone) {
            const $phoneBtn = document.createElement("button");
            $phoneBtn.className = "button";
            $phoneBtn.innerHTML = `<div class="buttonIcon phoneButton"></div><span>${(0, $07470c5219c7337c$export$180605366c04f0cd)().stores.cta.call}</span>`;
            $phoneBtn.addEventListener("click", ()=>{
                var _properties_contact;
                window.open(`tel:${(_properties_contact = properties.contact) === null || _properties_contact === void 0 ? void 0 : _properties_contact.phone}`, "_self");
            });
            $storeDetailsActions.appendChild($phoneBtn);
        }
        if ((_properties_contact1 = properties.contact) === null || _properties_contact1 === void 0 ? void 0 : _properties_contact1.website) {
            const $websiteBtn = document.createElement("button");
            $websiteBtn.className = "button";
            $websiteBtn.innerHTML = `<div class="buttonIcon websiteButton"></div><span>${(0, $07470c5219c7337c$export$180605366c04f0cd)().stores.cta.website}</span>`;
            $websiteBtn.addEventListener("click", ()=>{
                var _properties_contact;
                window.open(`${(_properties_contact = properties.contact) === null || _properties_contact === void 0 ? void 0 : _properties_contact.website}`, "_blank");
            });
            $storeDetailsActions.appendChild($websiteBtn);
        }
        return $storeDetailsActions;
    }
    getBackButton() {
        const $headerContainer = document.createElement("div");
        $headerContainer.className = "detailsStore__header";
        const $backBtn = document.createElement("button");
        $backBtn.className = "backButton";
        $backBtn.addEventListener("click", ()=>this.emit("back"));
        $backBtn.innerHTML = `<div class="backButton__icon"></div>`;
        $headerContainer.innerHTML = `<div class="detailsStore__headerTitle"></div>`;
        $headerContainer.appendChild($backBtn);
        return $headerContainer;
    }
    getEvents(properties) {
        var _properties_user_properties;
        const $eventsElements = document.createElement("div");
        $eventsElements.className = "eventsDetail";
        const events = (_properties_user_properties = properties.user_properties) === null || _properties_user_properties === void 0 ? void 0 : _properties_user_properties.events;
        if (events && events.length > 0) events.forEach((event)=>{
            const $eventElement = document.createElement("div");
            $eventElement.className = "collapsible";
            $eventElement.classList.add("sport");
            $eventElement.innerHTML = `<span class="collapsibleTitle">${event.name}</span><div class="collapsibleIcon"></div>`;
            $eventElement.addEventListener("click", ()=>this.toggleActive($eventElement));
            $eventsElements.appendChild($eventElement);
            const matchesByDate = this.groupEventRoundsByDate(event.rounds);
            if (matchesByDate && matchesByDate) {
                const $dateWiseContainer = document.createElement("div");
                $dateWiseContainer.className = "collapsibleSchedule";
                for (const [date, events] of Object.entries(matchesByDate)){
                    const dayDiv = document.createElement("div");
                    dayDiv.classList.add("day");
                    const dayHeader = document.createElement("h4");
                    dayHeader.textContent = date;
                    dayDiv.appendChild(dayHeader);
                    const ul = document.createElement("ul");
                    events.forEach((round)=>{
                        const li = document.createElement("li");
                        const eventSpan = document.createElement("span");
                        eventSpan.classList.add("event");
                        eventSpan.textContent = round.name;
                        li.appendChild(eventSpan);
                        if (round.medal) {
                            const medalElem = document.createElement("div");
                            medalElem.className = "iconMedal";
                            li.appendChild(medalElem);
                        }
                        const genderSpan = document.createElement("span");
                        genderSpan.classList.add("time");
                        genderSpan.textContent = round.gender === "Not Applicable" ? "NA" : round.gender;
                        li.appendChild(genderSpan);
                        const timeSpan = document.createElement("span");
                        timeSpan.classList.add("time");
                        timeSpan.textContent = new Date(round.dateTime).toLocaleTimeString("fr-FR", {
                            hour: "2-digit",
                            minute: "2-digit"
                        });
                        li.appendChild(timeSpan);
                        ul.appendChild(li);
                    });
                    dayDiv.appendChild(ul);
                    $dateWiseContainer.appendChild(dayDiv);
                    $eventsElements.appendChild($dateWiseContainer);
                }
            }
        });
        return $eventsElements;
    }
    groupEventRoundsByDate(rounds) {
        return rounds.reduce((acc, round)=>{
            const date = (0, $436938c94ed6ad8c$export$3d1fa75de54ffd7a)(round.dateTime);
            if (!acc[date]) acc[date] = [];
            acc[date].push(round);
            return acc;
        }, {});
    }
    updateEventCountdown_old(events) {
        const dateTimesNested = events.map((event)=>event.rounds.map((round)=>round.dateTime));
        const dateTimes = dateTimesNested.reduce((acc, val)=>acc.concat(val), []);
        const dates = dateTimes.map((dateTime)=>new Date(dateTime));
        const earliestDateTimestamp = Math.min(...dates.map((date)=>date.getTime()));
        const earliestDate = new Date(earliestDateTimestamp);
        const eventStartText = (0, $436938c94ed6ad8c$export$1c2b6984022f3a11)(earliestDate.toString());
        const $countdownElement = document.getElementsByClassName("detailsStore__event");
        if ($countdownElement && $countdownElement.length > 0) $countdownElement[0].innerHTML = eventStartText;
    }
    updateEventCountdown(events) {
        const dateTimesNested = events.map((event)=>event.rounds.map((round)=>round.dateTime));
        const dateTimes = dateTimesNested.reduce((acc, val)=>acc.concat(val), []);
        const dates = dateTimes.map((dateTime)=>new Date(dateTime));
        const now = new Date();
        const futureDates = dates.filter((date)=>{
            const isFutureDate = date.getTime() > now.getTime();
            // const isToday = date.toDateString() === now.toDateString();
            const isToday = date.toDateString() === now.toDateString() && date.getTime() >= now.getTime();
            return isFutureDate || isToday;
        });
        if (futureDates.length > 0) {
            const earliestDateTimestamp = Math.min(...futureDates.map((date)=>date.getTime()));
            const earliestDate = new Date(earliestDateTimestamp);
            const eventStartText = (0, $436938c94ed6ad8c$export$1c2b6984022f3a11)(earliestDate.toString());
            const $countdownElement = document.getElementsByClassName("detailsStore__event");
            if ($countdownElement && $countdownElement.length > 0) $countdownElement[0].innerHTML = eventStartText;
        }
    }
    toggleActive(element) {
        element.classList.toggle("active");
        const content = element.nextElementSibling;
        if ((content === null || content === void 0 ? void 0 : content.style.maxHeight) && (content === null || content === void 0 ? void 0 : content.style.maxHeight) != "0px") content.style.maxHeight = "0px";
        else content.style.maxHeight = content.scrollHeight + "px";
    }
}





class $232070fffd82843e$export$2e2bcd8739ae039 {
    async call(path, params, init) {
        params.key = this.apiKey;
        const apiUrl = `${this.baseUrl}${path}?${(0, $fb6f3ecaa0346039$export$89a7e74069fbb7af)(params)}`;
        return await fetch(apiUrl, {
            ...init
        });
    }
    constructor(params){
        this.apiKey = params.apiKey;
        this.baseUrl = params.baseUrl;
    }
}



class $38c4c6bad62fc18d$export$2e2bcd8739ae039 {
    searchStores({ ...params }) {
        const apiPath = "/stores/search/";
        const options = {
            method: "GET",
            headers: {
                Accept: "application/json"
            }
        };
        return this.httpClient.call(apiPath, params, options).then((response)=>{
            return this.processSearchStores(response);
        });
    }
    processSearchStores(response) {
        const status = response.status;
        if (status === 200) return response.json().then((data)=>{
            return data;
        });
        else if (status === 401) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["401"]);
        else if (status === 403) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["403"]);
        else if (status === 429) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["429"]);
        else if (status === 500) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["500"]);
        else if (status !== 200 && status !== 204) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors.other);
        return Promise.resolve(null);
    }
    constructor(httpClient){
        this.httpClient = httpClient;
    }
}



class $fd97562b8a2ebfc9$export$2e2bcd8739ae039 {
    route({ ...params }) {
        const apiPath = "/distance/route/json";
        const options = {
            method: "GET",
            headers: {
                Accept: "application/json"
            }
        };
        return this.httpClient.call(apiPath, params, options).then((response)=>{
            return this.processRoute(response);
        });
    }
    processRoute(response) {
        const status = response.status;
        if (status === 200) return response.json().then((data)=>{
            return data;
        });
        else if (status === 401) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["401"]);
        else if (status === 403) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["403"]);
        else if (status === 429) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["429"]);
        else if (status === 500) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["500"]);
        else if (status !== 200 && status !== 204) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors.other);
        return Promise.resolve(null);
    }
    constructor(httpClient){
        this.httpClient = httpClient;
    }
}



class $a3c701083f14db09$export$2e2bcd8739ae039 {
    geocode({ ...params }) {
        const apiPath = "/localities/geocode/";
        const options = {
            method: "GET",
            headers: {
                Accept: "application/json"
            }
        };
        return this.httpClient.call(apiPath, params, options).then((response)=>{
            return this.processGeocode(response);
        });
    }
    processGeocode(response) {
        const status = response.status;
        if (status === 200) return response.json().then((data)=>{
            return data;
        });
        else if (status === 401) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["401"]);
        else if (status === 403) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["403"]);
        else if (status === 429) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["429"]);
        else if (status === 500) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors["500"]);
        else if (status !== 200 && status !== 204) throw new Error((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.apiErrors.other);
        return Promise.resolve(null);
    }
    constructor(httpClient){
        this.httpClient = httpClient;
    }
}



class $c3fef9ff564a003b$export$e91aad2e7ca3cca3 {
    get stores() {
        return this._stores;
    }
    get distance() {
        return this._distance;
    }
    get geocode() {
        return this._geocode;
    }
    constructor(params){
        this.httpClient = new (0, $232070fffd82843e$export$2e2bcd8739ae039)({
            ...params,
            baseUrl: params.baseUrl || (0, $376e204b4320ccbe$export$44487a86467333c3)().urls.baseApiUrl,
            apiKey: params.apiKey || (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey
        });
        this._stores = new (0, $38c4c6bad62fc18d$export$2e2bcd8739ae039)(this.httpClient);
        this._distance = new (0, $fd97562b8a2ebfc9$export$2e2bcd8739ae039)(this.httpClient);
        this._geocode = new (0, $a3c701083f14db09$export$2e2bcd8739ae039)(this.httpClient);
    }
}


var $638d3b3056e92787$exports = {};
$638d3b3056e92787$exports = new URL("empty.d8f179eb.png", import.meta.url).toString();




var $7ef822eee1334c42$export$e16b04041918aede;
(function(StoresListComponentEvents) {
    StoresListComponentEvents["STORES_CHANGED"] = "stores_changed";
    StoresListComponentEvents["LOCALITY_CHANGED"] = "locality_changed";
    StoresListComponentEvents["QUERY_CHANGED"] = "query_changed";
    StoresListComponentEvents["STORE_SELECTED"] = "store_selected";
    StoresListComponentEvents["STORE_MOUSEENTER"] = "store_mouseenter";
    StoresListComponentEvents["STORE_MOUSELEAVE"] = "store_mouseleave";
    StoresListComponentEvents["RESET"] = "reset";
})($7ef822eee1334c42$export$e16b04041918aede || ($7ef822eee1334c42$export$e16b04041918aede = {}));
class $7ef822eee1334c42$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.api = new (0, $c3fef9ff564a003b$export$e91aad2e7ca3cca3)({
            apiKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey
        });
        this.$element = document.createElement("ul");
        this.$target.appendChild(this.$element);
        this.on("locality_changed", ()=>{
            this.searchStores();
        });
        this.on("query_changed", ()=>{
            this.searchStores();
        });
    }
    render() {
        if (this.state && this.$element) {
            var _this_state_stores;
            if ((_this_state_stores = this.state.stores) === null || _this_state_stores === void 0 ? void 0 : _this_state_stores.length) {
                var _this_state_stores1;
                const storesElements = (_this_state_stores1 = this.state.stores) === null || _this_state_stores1 === void 0 ? void 0 : _this_state_stores1.map((store)=>{
                    var _properties_open, _properties_contact, _properties_user_properties, _properties_user_properties1;
                    const name = store.properties.name.replace("Stage", (0, $07470c5219c7337c$export$180605366c04f0cd)().stores.name.Stage);
                    const properties = store.properties;
                    const $storeElement = document.createElement("li");
                    if ((_properties_open = properties.open) === null || _properties_open === void 0 ? void 0 : _properties_open.open_now) $storeElement.className = "summaryOpenedStore";
                    else $storeElement.className = "summaryStore";
                    $storeElement.dataset.storeId = store.properties.store_id;
                    $storeElement.innerHTML = `
                            <div class="summaryStore__name">${name}</div>
                            ${properties.address ? `<div class="summaryStore__address">${(0, $436938c94ed6ad8c$export$a4b8ee4ccc3b7327)(properties.address)}</div>` : ""}
                            ${((_properties_contact = properties.contact) === null || _properties_contact === void 0 ? void 0 : _properties_contact.phone) ? `<div class="summaryStore__phone">${(0, $436938c94ed6ad8c$export$adee39cd77054230)(properties.contact)}</div>` : ""}
                            ${((_properties_user_properties = properties.user_properties) === null || _properties_user_properties === void 0 ? void 0 : _properties_user_properties.distance) ? `<div class="summaryStore__distance">${((_properties_user_properties1 = properties.user_properties) === null || _properties_user_properties1 === void 0 ? void 0 : _properties_user_properties1.distance).text}</div>` : properties.distance ? `<div class="summaryStore__distance">${(0, $436938c94ed6ad8c$export$5f1d97f53c43eb95)(properties.distance)}</div>` : ""}`;
                    $storeElement.addEventListener("click", ()=>{
                        this.emit("store_selected", store);
                    });
                    $storeElement.addEventListener("mouseenter", ()=>{
                        this.emit("store_mouseenter", store);
                    });
                    $storeElement.addEventListener("mouseleave", ()=>{
                        this.emit("store_mouseleave", store);
                    });
                    return $storeElement;
                });
                this.$element.replaceChildren(...storesElements);
            } else {
                const $emptyResults = document.createElement("div");
                const messageHeader = this.state.stores ? (0, $07470c5219c7337c$export$180605366c04f0cd)().stores.messages.emptyHeader : (0, $07470c5219c7337c$export$180605366c04f0cd)().stores.messages.initialHeader;
                const messageBody = this.state.stores ? (0, $07470c5219c7337c$export$180605366c04f0cd)().stores.messages.emptyBody : (0, $07470c5219c7337c$export$180605366c04f0cd)().stores.messages.initialBody;
                $emptyResults.innerHTML = `
                <div class="summaryStore__empty">
                    <div>
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($638d3b3056e92787$exports))}" width="120">
                    </div>
                    <h3>${messageHeader}</h3>
                    <div>${messageBody}</div>
                <div>`;
                this.$element.replaceChildren($emptyResults);
            }
        }
    }
    searchStores() {
        if (this.state.nearbyLocation) {
            let params = Object.assign({}, (0, $376e204b4320ccbe$export$44487a86467333c3)().search.searchAPIParameters, {
                lat: this.state.nearbyLocation.lat,
                lng: this.state.nearbyLocation.lng
            });
            if (this.state.query) params = Object.assign({}, params, {
                query: this.state.query
            });
            this.api.stores.searchStores(params).then((response)=>{
                const storesList = response === null || response === void 0 ? void 0 : response.features.map((store)=>store);
                this.updateStoresWithDistanceMatrix(storesList).then((updatedStores)=>{
                    this.setState({
                        stores: updatedStores
                    });
                    this.emit("stores_changed", this.state);
                });
            }).catch((exception)=>{
                console.error(exception);
                this.setState({
                    stores: []
                });
            });
        } else {
            let params = (0, $376e204b4320ccbe$export$44487a86467333c3)().search.searchAPIParameters;
            if (this.state.query) params = Object.assign({}, params, {
                query: this.state.query
            });
            if (this.state.query !== "" && this.state.query !== undefined) this.api.stores.searchStores(params).then((response)=>{
                const storesList = response === null || response === void 0 ? void 0 : response.features.map((store)=>store);
                this.setState({
                    stores: storesList
                });
                this.emit("stores_changed", this.state);
            }).catch((exception)=>{
                console.error(exception);
                this.setState({
                    stores: []
                });
            });
            else {
                this.setState({
                    stores: undefined
                });
                this.emit("reset");
            }
        }
    }
    updateStoresWithDistanceMatrix(stores) {
        return new Promise((resolve, reject)=>{
            const distanceService = new woosmap.map.DistanceService();
            const distanceMatrixRequest = {
                ...(0, $376e204b4320ccbe$export$44487a86467333c3)().directions.distanceMatrixOptions,
                origins: [
                    this.state.nearbyLocation
                ],
                destinations: stores.map((store)=>{
                    return {
                        lat: store.geometry.coordinates[1],
                        lng: store.geometry.coordinates[0]
                    };
                })
            };
            distanceService.getDistanceMatrix(distanceMatrixRequest).then((response)=>{
                if (response.status === "OK") {
                    stores.forEach((store, i)=>{
                        const result = response.rows[0].elements[i];
                        if (result.status === "OK") {
                            store.properties.user_properties = store.properties.user_properties || {};
                            var _result_distance;
                            store.properties.user_properties["distance"] = (_result_distance = result.distance) !== null && _result_distance !== void 0 ? _result_distance : store.properties.user_properties["distance"];
                        }
                    });
                    stores.sort((a, b)=>{
                        var _a_properties_user_properties, _b_properties_user_properties;
                        return (((_a_properties_user_properties = a.properties.user_properties) === null || _a_properties_user_properties === void 0 ? void 0 : _a_properties_user_properties.distance).value || 0) - (((_b_properties_user_properties = b.properties.user_properties) === null || _b_properties_user_properties === void 0 ? void 0 : _b_properties_user_properties.distance).value || 0);
                    });
                }
                resolve(stores); // Resolve with stores even if Distance Matrix request failed
            }).catch((error)=>{
                console.error(error);
                reject(error);
            });
        });
    }
    getStoreState() {
        return this.state;
    }
}






var $f5cfc18e60f3f1c9$export$f5c69f55b3b1a646;
(function(FilterComponentEvents) {
    FilterComponentEvents["FILTERS_UPDATED"] = "filters_updated";
})($f5cfc18e60f3f1c9$export$f5c69f55b3b1a646 || ($f5cfc18e60f3f1c9$export$f5c69f55b3b1a646 = {}));
class $f5cfc18e60f3f1c9$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "filterHeader collapsible";
        this.$element.innerHTML = `<span class="collapsibleTitle">${(0, $07470c5219c7337c$export$180605366c04f0cd)().filtering.servicesTitle}</span><div class="collapsibleIcon"></div>`;
        this.$element.addEventListener("click", ()=>this.toggleActive());
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            const $listCategories = document.createElement("div");
            $listCategories.className = "filterList collapsibleContent";
            const servicesCategoryHTML = (0, $376e204b4320ccbe$export$44487a86467333c3)().search.availableServices.map((category)=>{
                const $category = document.createElement("div");
                $category.innerHTML = `<div class='filterList filter-group'>${category.category}</div>`;
                const $listServices = document.createElement("ul");
                $listServices.className = "filterList";
                const servicesHTML = category.items.map((service)=>{
                    const $service = document.createElement("li");
                    $service.dataset.servicekey = service.serviceKey;
                    $service.dataset.servicename = (0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().filtering.services, service.serviceKey);
                    $service.dataset.serviceType = category.category === "Sports" ? "type" : "tag";
                    $service.innerHTML = `
                    <button class="button">
                    <div class='iconService iconService__${service.serviceKey}'></div>
                    <div class='filterList__serviceName'>${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().filtering.services, service.serviceKey)}</div>
                    <div class="filterList__iconWrapper"></div>
                    </button>`;
                    $service.addEventListener("click", ()=>{
                        $service.classList.toggle("active");
                        this.updateActiveFilters();
                    });
                    return $service;
                });
                $listServices.replaceChildren(...servicesHTML);
                $category.appendChild($listServices);
                return $category;
            });
            $listCategories.replaceChildren(...servicesCategoryHTML);
            this.$target.appendChild($listCategories);
        }
    }
    toggleActive() {
        this.$element.classList.toggle("active");
        const content = this.$element.nextElementSibling;
        if ((content === null || content === void 0 ? void 0 : content.style.maxHeight) && (content === null || content === void 0 ? void 0 : content.style.maxHeight) != "0px") content.style.maxHeight = "0px";
        else content.style.maxHeight = content.scrollHeight + "px";
    }
    setDateToFilter() {
        this.emit("filters_updated", this.state.activeFilters);
    }
    updateActiveFilters() {
        const filters = [];
        const filterElements = document.querySelectorAll(".filterList .active");
        filterElements.forEach(($filterLI)=>{
            if ($filterLI.dataset && $filterLI.dataset.servicename) filters.push($filterLI.dataset.servicename);
        });
        const queryString = filters.map((servicename)=>`type:"${servicename}"`).join(" OR ");
        this.setState({
            activeFilters: filters
        }, true, ()=>this.emit("filters_updated", queryString));
    }
}





var $82c102faa09fd15a$export$5685af560c13eb53;
(function(TravelModeComponentEvents) {
    TravelModeComponentEvents["TRAVEL_MODE_CHANGED"] = "travel_mode_changed";
})($82c102faa09fd15a$export$5685af560c13eb53 || ($82c102faa09fd15a$export$5685af560c13eb53 = {}));
class $82c102faa09fd15a$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "travelModeSelector";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            const travelModesHTML = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.travelModes.map((travelMode)=>{
                const $travelMode = document.createElement("div");
                $travelMode.dataset.mode = travelMode.modeKey;
                $travelMode.className = travelMode.modeKey === this.state.selectedTravelMode ? "travelMode travelMode__selected" : "travelMode";
                $travelMode.innerHTML = `
                                <button role="radio">
                                <img alt="${travelMode.modeKey}" class="iconTravelMode iconTravelMode__${travelMode.modeKey}"
                                     src="${travelMode.defaultIcon}"/>
                                <img alt="${travelMode.modeKey}" class="iconTravelMode iconTravelMode__${travelMode.modeKey}__selected"
                                     src="${travelMode.selectedIcon}"/>
                                </button>`;
                $travelMode.addEventListener("click", ()=>{
                    if ($travelMode.dataset && $travelMode.dataset.mode) this.toggleTravelMode($travelMode);
                });
                return $travelMode;
            });
            this.$element.replaceChildren(...travelModesHTML);
        }
    }
    toggleTravelMode($travelMode) {
        this.setState({
            selectedTravelMode: $travelMode.dataset.mode
        }, true, ()=>{
            document.querySelectorAll(".travelMode").forEach((el)=>el.classList.remove("travelMode__selected"));
            $travelMode.classList.add("travelMode__selected");
            this.emit("travel_mode_changed", this.state.selectedTravelMode);
        });
    }
}











var $81ab1a4151e5f2b1$export$bec4f8eff0df0668;
(function(SearchComponentEvents) {
    SearchComponentEvents["SELECTED_LOCALITY"] = "selected_locality";
    SearchComponentEvents["SEARCH_CLEAR"] = "search_clear";
    SearchComponentEvents["SELECTED_STORE"] = "selected_store";
})($81ab1a4151e5f2b1$export$bec4f8eff0df0668 || ($81ab1a4151e5f2b1$export$bec4f8eff0df0668 = {}));
class $81ab1a4151e5f2b1$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        const $multiSearchInputContainer = document.createElement("div");
        $multiSearchInputContainer.className = "multisearch__container";
        this.$element = document.createElement("input");
        this.$element.className = "search__input";
        this.$element.setAttribute("placeholder", (0, $07470c5219c7337c$export$180605366c04f0cd)().search.placeholder);
        this.$element.setAttribute("aria-label", (0, $07470c5219c7337c$export$180605366c04f0cd)().search.placeholder);
        this.$element.setAttribute("aria-autocomplete", "list");
        this.$element.setAttribute("autocomplete", "off");
        this.$element.id = this.state.inputID;
        $multiSearchInputContainer.appendChild(this.$element);
        this.$target.appendChild($multiSearchInputContainer);
    }
    render() {
        if (this.state && this.$element) (0, $5a3b137193fd24f6$export$2cb99e4be0dc4646)({
            url: (0, $376e204b4320ccbe$export$44487a86467333c3)().urls.multiSearchJS,
            params: {
                key: this.state.woosmapPublicKey
            }
        }).then(()=>this.initSearchView()).catch((error)=>{
            console.error((0, $fb6f3ecaa0346039$export$77ad94ebf1c2b9ed)((0, $07470c5219c7337c$export$180605366c04f0cd)().errors.loadingLibrary, {
                "library": "Woosmap MultiSearch JS"
            }), error);
        });
    }
    initSearchView() {
        const searchOptions = (0, $fb6f3ecaa0346039$export$4950aa0f605343fb)({
            ...this.state.searchOptions
        }, {
            language: (0, $07470c5219c7337c$export$3814be8b8b1016be)().toLowerCase()
        });
        this.multiSearch = window.woosmap.multisearch(searchOptions);
        const $inputContainer = document.getElementById(this.state.inputID).parentElement;
        const $inputElement = document.getElementById(this.state.inputID);
        $inputElement === null || $inputElement === void 0 ? void 0 : $inputElement.addEventListener("input", ()=>this.handleAutoComplete($inputElement));
        $inputContainer.appendChild($inputElement);
        this.state.featuresBtn.forEach((feature)=>{
            if (feature === "search") this.manageSearchButton($inputContainer);
            if (feature === "clear") this.manageClearButton($inputContainer);
            if (feature === "geolocate") this.manageGeolocateButton($inputContainer);
        });
        this.selectLocality();
    }
    handleAutoComplete($inputElement) {
        const input = $inputElement.value;
        input.replace('"', '\\"').replace(/^\s+|\s+$/g, "");
        if (input !== "") this.multiSearch.autocompleteMulti(input).then((results)=>this.displaySuggestions(results), (error)=>console.error(`Error autocomplete localities: ${error}`));
    }
    displaySuggestions(results) {
        const $inputElement = document.getElementById((0, $7f868f7298b680d4$export$2e2bcd8739ae039).searchInputID);
        const $suggestionsList = document.getElementById((0, $7f868f7298b680d4$export$2e2bcd8739ae039).suggestionListID);
        $suggestionsList.className = "suggestions-list";
        if ($inputElement && $suggestionsList) {
            $suggestionsList.innerHTML = "";
            if (results.length > 0) {
                var _this_$element_parentNode;
                results.forEach((result)=>{
                    const li = document.createElement("li");
                    li.className = `${result.api}-api`;
                    var _this_formatPredictionList;
                    li.innerHTML = (_this_formatPredictionList = this.formatPredictionList(result)) !== null && _this_formatPredictionList !== void 0 ? _this_formatPredictionList : "";
                    li.addEventListener("click", ()=>{
                        var _result_description;
                        $inputElement.value = (_result_description = result.description) !== null && _result_description !== void 0 ? _result_description : "";
                        $suggestionsList.style.display = "none";
                        if (result.api === "store") {
                            const api = new (0, $c3fef9ff564a003b$export$e91aad2e7ca3cca3)({
                                apiKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey
                            });
                            api.stores.searchStores({
                                query: `idstore:="${result.id}"`
                            }).then((response)=>{
                                const details = response === null || response === void 0 ? void 0 : response.features[0];
                                const searchLocation = {
                                    name: details.properties.name,
                                    publicId: details.properties.store_id,
                                    location: {
                                        lat: details.geometry.coordinates[1],
                                        lng: details.geometry.coordinates[0]
                                    }
                                };
                                this.setState({
                                    selectedLocality: searchLocation
                                }, true);
                                this.emit("selected_store", details);
                            }).catch((exception)=>{
                                console.error(exception);
                            });
                        } else this.multiSearch.detailsMulti({
                            id: result.id,
                            api: result.api
                        }).then((details)=>{
                            const searchLocation = {
                                name: details.formatted_address || details.name,
                                publicId: details.id,
                                location: details.geometry.location
                            };
                            this.setState({
                                selectedLocality: searchLocation
                            }, true);
                            this.emit("selected_locality", searchLocation);
                        });
                    });
                    $suggestionsList.appendChild(li);
                });
                $suggestionsList.style.display = "block";
                (_this_$element_parentNode = this.$element.parentNode) === null || _this_$element_parentNode === void 0 ? void 0 : _this_$element_parentNode.appendChild($suggestionsList);
            }
        }
    }
    formatPredictionList(result) {
        const predictionClass = "no-viewpoint";
        const formatted_name = result.highlight;
        let html = "";
        html += `<div class="api-icon"></div><div class="prediction ${predictionClass}">${formatted_name}</div>`;
        return html;
    }
    selectLocality() {
        if (this.state.selectedLocality) {
            this.setLocality(this.state.selectedLocality.name || "");
            this.emit("selected_locality", this.state.selectedLocality);
        }
    }
    manageSearchButton($inputContainer) {
        const $searchBtn = document.createElement("div");
        $searchBtn.className = "search__searchBtn";
        $searchBtn.innerHTML = `<button type="button" aria-label="${(0, $07470c5219c7337c$export$180605366c04f0cd)().search.submitLabel}"></button>`;
        $searchBtn.addEventListener("click", ()=>{
            if (this.state.selectedLocality) this.emit("selected_locality", this.state.selectedLocality);
            else this.$element.focus();
        });
        $inputContainer.appendChild($searchBtn);
    }
    manageClearButton($inputContainer) {
        const $clearBtn = document.createElement("div");
        $clearBtn.className = "search__clearBtn";
        $clearBtn.innerHTML = `<button type="button" aria-label="${(0, $07470c5219c7337c$export$180605366c04f0cd)().search.clearLabel}"></button>`;
        $clearBtn.addEventListener("click", ()=>this.handleClearBtnClick($clearBtn, $inputContainer));
        [
            "input",
            "locality_changed"
        ].forEach((evt)=>this.$element.addEventListener(evt, ()=>this.handleInputChange($clearBtn)));
        $clearBtn.style.display = "none";
        $inputContainer.appendChild($clearBtn);
    }
    setLocality(name) {
        this.$element.value = name;
        this.$element.dispatchEvent(new Event("locality_changed"));
    }
    manageGeolocateButton($inputContainer) {
        const geolocateComponent = new (0, $f6cc29bbdc6ec6b8$export$2e2bcd8739ae039)({
            $target: $inputContainer,
            initialState: {}
        });
        geolocateComponent.on((0, $f6cc29bbdc6ec6b8$export$d34e68953e15144d).GEOLOCATION_FOUND, (geolocation)=>{
            if (geolocation) {
                const searchLocation = {
                    name: geolocation.name,
                    location: {
                        lat: geolocation.latitude,
                        lng: geolocation.longitude
                    }
                };
                this.setLocality((0, $07470c5219c7337c$export$180605366c04f0cd)().search.yourLocation);
                this.setState({
                    selectedLocality: searchLocation
                }, true);
                this.emit("selected_locality", searchLocation);
            }
        });
    }
    getLocality() {
        if (this.state) return this.state.selectedLocality;
    }
    constructor(...args){
        super(...args);
        this.handleClearBtnClick = ($clearBtn, $inputContainer)=>{
            const $emptyButton = $inputContainer.querySelector(".localities-empty-button");
            const $suggestionsList = document.getElementById((0, $7f868f7298b680d4$export$2e2bcd8739ae039).suggestionListID);
            if ($emptyButton) {
                $emptyButton.click();
                $clearBtn.style.display = "none";
            } else {
                this.$element.value = "";
                $clearBtn.style.display = "none";
                this.$element.focus();
            }
            $suggestionsList.innerHTML = "";
            this.emit("search_clear");
        };
        this.handleInputChange = ($clearBtn)=>{
            if (this.$element.value.length === 0) $clearBtn.style.display = "none";
            else $clearBtn.style.display = "block";
        };
    }
}





var $031cbdd27b824ea2$exports = {};
$031cbdd27b824ea2$exports = new URL("loader.40e04524.svg", import.meta.url).toString();




var $2cc4a6b94ded5f9b$export$ebf4dc7348200b05;
(function(RoutesSummaryComponentEvents) {
    RoutesSummaryComponentEvents["ROUTE_INDEX_CHANGED"] = "route_index_changed";
    RoutesSummaryComponentEvents["ROADBOOK_SHOW"] = "roadbook_show";
})($2cc4a6b94ded5f9b$export$ebf4dc7348200b05 || ($2cc4a6b94ded5f9b$export$ebf4dc7348200b05 = {}));
class $2cc4a6b94ded5f9b$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "routesSummary";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            if (this.state.isLoading) this.setLoading();
            else if (this.state.routes && this.state.routes.length) {
                const routesSummary = this.state.routes.map((route, index)=>{
                    const summary = `${route.legs[0].start_address}`;
                    const duration = `${route.legs[0].duration.text}`;
                    const distance = `${route.legs[0].distance.text}`;
                    const travelModeIcon = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.travelModes.filter(({ modeKey: modeKey })=>modeKey === this.state.travelMode)[0].darkIcon;
                    const $routeSummary = document.createElement("div");
                    const tripSummary = this.state.travelMode === "DRIVING" ? `${duration} ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.withoutTraffic}` : duration;
                    $routeSummary.className = index === this.state.selectedRouteIndex ? "directionTrip directionTrip__selected" : "directionTrip";
                    $routeSummary.dataset.index = index.toString();
                    $routeSummary.innerHTML = `
                        <img alt="${this.state.travelMode}" src="${travelModeIcon}" class="directionTrip__travelModeIcon">
                        <div class="directionTrip__description">
                            <div class="directionTrip__numbers">
                                <div class="directionTrip__duration">${duration}</div>
                                <div class="directionTrip__distance"> ${distance}</div>
                            </div>
                            <div>
                                <div class="directionTrip__title">${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.via} ${summary}</div>
                                <div class="directionTrip__summary">
                                    <div >${tripSummary}</div>
                                </div>
                            </div>
                            <div class="directionTrip__detailsMsg" data-detailsindex="{{ rendererIndex }}">${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.details}</div>
                        </div>`;
                    $routeSummary.addEventListener("click", ()=>{
                        if ($routeSummary.dataset && $routeSummary.dataset.index) {
                            const routeIndex = Number($routeSummary.dataset.index);
                            if (routeIndex === this.state.selectedRouteIndex) this.emit("roadbook_show");
                            else this.selectRoute(routeIndex);
                        }
                    });
                    return $routeSummary;
                });
                this.$element.replaceChildren(...routesSummary);
            } else this.setEmptyResults();
        }
    }
    setEmptyResults() {
        let messageBody;
        const $emptyResult = document.createElement("div");
        messageBody = (0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.initialBody;
        if (this.state.origin && this.state.destination) messageBody = `${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.error} 
                            ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.from} "<strong>${this.state.origin}</strong>" 
                            ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.to} "<strong>${this.state.destination}</strong>" 
                            ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.forTravelMode} <strong>${this.state.travelMode}</strong>`;
        if (this.state.error) messageBody += `<div class="directionTrip__error">${this.state.error}</div>`;
        if (this.state.travelMode === "TRANSIT") $emptyResult.style.display = "none";
        $emptyResult.innerHTML = `
                    <div class="directionTrip__empty">
                    <div>${messageBody}</div>
                    <div>`;
        this.$element.replaceChildren($emptyResult);
    }
    setLoading() {
        const $loader = document.createElement("div");
        $loader.id = "loader";
        $loader.innerHTML = `<img alt="loading..." src=${0, (/*@__PURE__*/$parcel$interopDefault($031cbdd27b824ea2$exports))}>`;
        this.$element.replaceChildren($loader);
    }
    selectRoute(routeIndex) {
        this.setState({
            selectedRouteIndex: routeIndex
        }, true, ()=>{
            const $routeSummary = this.$element.querySelector(`[data-index="${this.state.selectedRouteIndex}"]`);
            document.querySelectorAll(".directionTrip").forEach((el)=>el.classList.remove("directionTrip__selected"));
            $routeSummary.classList.add("directionTrip__selected");
            this.emit("route_index_changed", this.state.selectedRouteIndex);
        });
    }
}





var $c41cf0e9f2a5c100$export$da1f36ab6d8337bc;
(function(RouteRoadbookComponentEvents) {
    RouteRoadbookComponentEvents["BACK"] = "back";
})($c41cf0e9f2a5c100$export$da1f36ab6d8337bc || ($c41cf0e9f2a5c100$export$da1f36ab6d8337bc = {}));
class $c41cf0e9f2a5c100$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        if (this.$target.children.length > 0) {
            const node = this.$target.children[0];
            this.$target.removeChild(node);
        }
        this.$element = document.createElement("div");
        this.$element.className = "routeRoadbook";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.$target.children.length > 0) this.init();
        if (this.state && this.$element) {
            const originText = `${this.state.route.legs[0].start_address}`;
            const destinationText = `${this.state.route.legs[0].end_address}`;
            const duration = `${this.state.route.legs[0].duration.text}`;
            const distance = `${this.state.route.legs[0].distance.text}`;
            const directionLink = this.getDirectionGoogleMapsUrl(this.state.route.legs[0].end_location);
            const $roadbookHeader = document.createElement("div");
            $roadbookHeader.className = "routeRoadbook__header";
            $roadbookHeader.innerHTML = `
                                <span class="routeRoadbook__headerFromTo">
                                    <div class="routeRoadbook__headerWaypoint"> ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.from} <span class="routeRoadbook__headerFrom">${originText}</span></div>
                                    <div class="routeRoadbook__headerWaypoint"> ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.to} <span class="routeRoadbook__headerTo">${destinationText}</span></div>
                                </span>`;
            const $roadbookBody = document.createElement("div");
            $roadbookBody.className = "routeRoadbook__body";
            $roadbookBody.innerHTML = `
                                <div class="routeRoadbook__actions">
                                    <a href="${directionLink}" target="_blank" title="${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.openGoogleMaps}"><button class="routeRoadbook__actionsButton"></button></a>
                                </div>
                                <div class="routeRoadbook__summaryHeader">
                                  <span>
                                    <span class="delay" >${duration} </span>
                                    <span class="routeRoadbook__summarySubtitle">(<span >${distance}</span>)</span>
                                  </span>
                                  <span class="routeRoadbook__summaryDescription">${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.via} ${originText}</span>
                                </div>`;
            const $backBtn = document.createElement("button");
            $backBtn.className = "routeRoadbook__headerBack";
            $backBtn.addEventListener("click", ()=>this.emit("back"));
            $roadbookHeader.prepend($backBtn);
            $roadbookBody.appendChild(this.getHTMLInstructions());
            this.$element.replaceChildren(...[
                $roadbookHeader,
                $roadbookBody
            ]);
            this.styleOnScroll($roadbookBody);
        }
    }
    getDirectionGoogleMapsUrl(latlng) {
        return `https://www.google.fr/maps/dir//${latlng.lat},${latlng.lng}`;
    }
    getDirectionStepIcon(action) {
        if (action) {
            const stepIconObj = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.stepsIcon.filter(({ index: index })=>index === action)[0];
            if (stepIconObj) {
                const className = stepIconObj.key.endsWith("Right") ? "reverse" : "";
                return `<div class="routeRoadbook__stepIcon routeRoadbook__stepIcon${className}">
                            <img alt="${stepIconObj.key}" src="${stepIconObj.icon}">
                        </div>`;
            } else return `<div class="routeRoadbook__stepIcon routeRoadbook__stepIcon${action}"></div>`;
        }
        return "";
    }
    getDirectionInstructionStep(instructions) {
        if (instructions) {
            if (instructions.summary) return `<div class="routeRoadbook__stepBody">
                            <span>${instructions.summary}</span>
                        </div>`;
        }
        return "";
    }
    getDirectionInstructionDistance(distance) {
        const $distanceSeperator = document.createElement("div");
        if (distance) {
            $distanceSeperator.className = "routeRoadbook__stepDistance";
            $distanceSeperator.innerHTML = `<div class="routeRoadbook__stepDistanceSeparator"></div>
                    <div class="routeRoadbook__stepDistanceText">${distance}</div>`;
        }
        return $distanceSeperator;
    }
    getWaypoint(address) {
        const $waypoint = document.createElement("div");
        $waypoint.className = "routeRoadbook__waypoint";
        $waypoint.innerHTML = `<span><h4 class="routeRoadbook__waypointAddress">${address}</h4></span>`;
        return $waypoint;
    }
    getHTMLInstructions() {
        const $instructions = document.createElement("div");
        $instructions.className = "routeRoadbook__steps";
        if (this.state.route.legs[0].steps) {
            const $instructionsSteps = this.state.route.legs[0].steps.map((step)=>{
                const $step = document.createElement("div");
                const iconStep = this.getDirectionStepIcon(step.instructions.action);
                const instructionStep = this.getDirectionInstructionStep(step.instructions);
                const $distanceStep = this.getDirectionInstructionDistance(step.distance);
                $step.innerHTML = `<div class="routeRoadbook__step">${iconStep}${instructionStep}</div>`;
                $step.appendChild($distanceStep);
                return $step;
            });
            $instructionsSteps.unshift(this.getWaypoint(this.state.route.legs[0].start_address));
            $instructionsSteps.push(this.getWaypoint(this.state.route.legs[0].end_address));
            $instructions.replaceChildren(...$instructionsSteps);
        }
        return $instructions;
    }
    styleOnScroll($roadbookBody) {
        $roadbookBody === null || $roadbookBody === void 0 ? void 0 : $roadbookBody.addEventListener("scroll", ()=>{
            const scroll = $roadbookBody.scrollTop;
            if (scroll > 0) $roadbookBody.classList.add("active");
            else $roadbookBody.classList.remove("active");
        });
    }
}





var $6e78ed18e1e28399$export$61b319a33691e777;
(function(DirectionsOptionsComponentEvents) {
    DirectionsOptionsComponentEvents["AVOID_UPDATED"] = "avoid_updated";
    DirectionsOptionsComponentEvents["UNIT_UPDATED"] = "unit_updated";
    DirectionsOptionsComponentEvents["TRAVEL_MODE_CHANGED"] = "travel_mode_changed";
})($6e78ed18e1e28399$export$61b319a33691e777 || ($6e78ed18e1e28399$export$61b319a33691e777 = {}));
class $6e78ed18e1e28399$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "directionsOptionsHeader collapsible";
        this.$element.innerHTML = `<span class="collapsibleTitle">${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.options}</span><div class="collapsibleIcon"></div>`;
        this.$element.addEventListener("click", ()=>this.toggleActive());
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            const elements = document.getElementsByClassName("directionsOptions collapsibleContent");
            Array.from(elements).forEach((element)=>{
                element.remove();
            });
            const $avoidOptionsContainer = document.createElement("div");
            $avoidOptionsContainer.className = "directionsOptions__list";
            const $avoidOptionsContent = document.createElement("div");
            $avoidOptionsContent.className = "directionsOptions__content";
            $avoidOptionsContent.innerHTML = `<span class='directionsOptions__header'>${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.avoid}</span>`;
            let $avoidOptions;
            if (this.state.isTransit) $avoidOptions = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.avoidTransitOptions.map((avoidOption)=>{
                const $avoidInput = document.createElement("div");
                $avoidInput.className = "directionsOptions__input";
                const checked = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.directionsOptions.avoid.includes(avoidOption.paramKey) ? "checked" : "";
                $avoidInput.innerHTML = `
                        <input id="avoid${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().directions.avoidTransitOptions, avoidOption.paramKey)}" aria-label="Avoid ${avoidOption.paramKey}" name="avoidParams" type="checkbox" 
                               value="${avoidOption.paramKey}" ${checked}>
                        <label for="avoid${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().directions.avoidTransitOptions, avoidOption.paramKey)}">${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().directions.avoidTransitOptions, avoidOption.paramKey)}</label>`;
                $avoidInput.addEventListener("click", (event)=>{
                    if (event.target.nodeName === "INPUT") this.updateAvoidPreferences();
                });
                return $avoidInput;
            });
            else $avoidOptions = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.avoidOptions.map((avoidOption)=>{
                const $avoidInput = document.createElement("div");
                $avoidInput.className = "directionsOptions__input";
                const checked = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.directionsOptions.avoid.includes(avoidOption.paramKey) ? "checked" : "";
                $avoidInput.innerHTML = `
                        <input id="avoid${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().directions.avoidOptions, avoidOption.paramKey)}" aria-label="Avoid ${avoidOption.paramKey}" name="avoidParams" type="checkbox" 
                               value="${avoidOption.paramKey}" ${checked}>
                        <label for="avoid${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().directions.avoidOptions, avoidOption.paramKey)}">${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().directions.avoidOptions, avoidOption.paramKey)}</label>`;
                $avoidInput.addEventListener("click", (event)=>{
                    if (event.target.nodeName === "INPUT") this.updateAvoidPreferences();
                });
                return $avoidInput;
            });
            $avoidOptionsContent.append(...$avoidOptions);
            $avoidOptionsContainer.replaceChildren($avoidOptionsContent);
            const $listOptions = document.createElement("div");
            $listOptions.className = "directionsOptions collapsibleContent";
            if (!this.state.isTransit) {
                const $unitOptionsContainer = document.createElement("div");
                $unitOptionsContainer.className = "directionsOptions__list";
                const $unitOptionsContent = document.createElement("div");
                $unitOptionsContent.className = "directionsOptions__content";
                $unitOptionsContent.innerHTML = `<span class='directionsOptions__header'>${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.units}</span>`;
                const $unitOptions = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.unitOptions.map((unitOption)=>{
                    const $unitInput = document.createElement("div");
                    $unitInput.className = "directionsOptions__input";
                    const checked = unitOption.paramKey === (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.directionsOptions.unitSystem ? "checked" : "";
                    $unitInput.innerHTML = `
                        <input id="unit${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().directions.unitOptions, unitOption.paramKey)}" aria-label="Unit ${unitOption.paramKey}" name="distanceUnits" type="radio" 
                               value="${unitOption.paramKey}" ${checked}>
                        <label for="unit${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().directions.unitOptions, unitOption.paramKey)}">${(0, $07470c5219c7337c$export$236350842f3cd9bc)((0, $07470c5219c7337c$export$180605366c04f0cd)().directions.unitOptions, unitOption.paramKey)}</label>`;
                    $unitInput.addEventListener("click", (event)=>{
                        if (event.target.nodeName === "INPUT") this.changeDistanceUnits();
                    });
                    return $unitInput;
                });
                $unitOptionsContent.append(...$unitOptions);
                $unitOptionsContainer.replaceChildren($unitOptionsContent);
                $listOptions.replaceChildren(...[
                    $avoidOptionsContainer,
                    $unitOptionsContainer
                ]);
            } else $listOptions.replaceChildren(...[
                $avoidOptionsContainer
            ]);
            this.$target.appendChild($listOptions);
        }
    }
    toggleActive() {
        this.$element.classList.toggle("active");
        const content = this.$element.nextElementSibling;
        if ((content === null || content === void 0 ? void 0 : content.style.maxHeight) && (content === null || content === void 0 ? void 0 : content.style.maxHeight) != "0px") content.style.maxHeight = "0px";
        else content.style.maxHeight = content.scrollHeight + "px";
    }
    updateAvoidPreferences() {
        const avoids = [];
        const optionsElements = document.querySelectorAll('input[name="avoidParams"]:checked');
        optionsElements.forEach(($avoidCheckbox)=>{
            avoids.push($avoidCheckbox.value);
        });
        this.setState({
            avoidOptions: avoids
        }, true, ()=>this.emit("avoid_updated", avoids));
    }
    changeDistanceUnits() {
        const distanceUnit = document.querySelector('input[name="distanceUnits"]:checked').value;
        this.setState({
            distanceUnit: distanceUnit
        }, true, ()=>this.emit("unit_updated", distanceUnit));
    }
}








var $cea17e7de1cf453d$export$f72d68ecd7c295b1;
(function(TransitSummaryComponentEvents) {
    TransitSummaryComponentEvents["ROUTE_INDEX_CHANGED"] = "route_index_changed";
    TransitSummaryComponentEvents["ROADBOOK_SHOW"] = "roadbook_show";
})($cea17e7de1cf453d$export$f72d68ecd7c295b1 || ($cea17e7de1cf453d$export$f72d68ecd7c295b1 = {}));
class $cea17e7de1cf453d$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.className = "routesSummary";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) {
            if (this.state.isLoading) this.setLoading();
            else if (this.state.routes && this.state.routes.length) {
                const transitSummary = this.state.routes.map((route, index)=>{
                    var _route_legs_find;
                    const totalDistance = route.legs.reduce((sum, { distance: distance })=>sum + distance, 0);
                    const startName = ((_route_legs_find = route.legs.find((leg)=>leg.start_location && leg.start_location.name !== null)) === null || _route_legs_find === void 0 ? void 0 : _route_legs_find.start_location.name) || "Walking";
                    const duration = `${route.duration}`;
                    const travelModeIcon = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.travelModes.filter(({ modeKey: modeKey })=>modeKey === this.state.travelMode)[0].darkIcon;
                    const $transitSummary = document.createElement("div");
                    $transitSummary.className = index === this.state.selectedRouteIndex ? "directionTrip directionTrip__selected" : "directionTrip";
                    $transitSummary.dataset.index = index.toString();
                    $transitSummary.innerHTML = `
                        <img alt="${this.state.travelMode}" src="${travelModeIcon}" class="directionTrip__travelModeIcon">
                        <div class="directionTrip__description">
                            <div>
                                <div class="directionTrip__duration">${this.formatTime(parseInt(duration))}</div>
                                <div class="directionTrip__distance"> ${this.formatDistance(totalDistance)}</div>
                            </div>         
                        </div>`;
                    $transitSummary.appendChild(this.getHTMLForLegs(route));
                    $transitSummary.appendChild(this.getHTMLForDetailsLink());
                    $transitSummary.addEventListener("click", ()=>{
                        if ($transitSummary.dataset && $transitSummary.dataset.index) {
                            const routeIndex = Number($transitSummary.dataset.index);
                            if (routeIndex === this.state.selectedRouteIndex) this.emit("roadbook_show");
                            else this.selectRoute(routeIndex);
                        }
                    });
                    return $transitSummary;
                });
                this.$element.replaceChildren(...transitSummary);
            } else this.setEmptyResults();
        }
    }
    setEmptyResults() {
        let messageBody;
        const $emptyResult = document.createElement("div");
        messageBody = (0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.initialBody;
        if (this.state.origin && this.state.destination) messageBody = `${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.error} 
                            ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.from} "<strong>${this.state.origin}</strong>" 
                            ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.to} "<strong>${this.state.destination}</strong>" 
                            ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.forTravelMode} <strong>${this.state.travelMode}</strong>`;
        if (this.state.error) messageBody += `<div class="directionTrip__error">${this.state.error}</div>`;
        $emptyResult.innerHTML = `
                    <div class="directionTrip__empty">
                    <div>${messageBody}</div>
                    <div>`;
        this.$element.replaceChildren($emptyResult);
        if (this.state.travelMode !== "TRANSIT") $emptyResult.style.display = "none";
    }
    setLoading() {
        const $loader = document.createElement("div");
        $loader.id = "loader";
        $loader.innerHTML = `<img alt="loading..." src=${0, (/*@__PURE__*/$parcel$interopDefault($031cbdd27b824ea2$exports))}>`;
        this.$element.replaceChildren($loader);
    }
    selectRoute(routeIndex) {
        this.setState({
            selectedRouteIndex: routeIndex
        }, true, ()=>{
            const $routeSummary = this.$element.querySelector(`[data-index="${this.state.selectedRouteIndex}"]`);
            document.querySelectorAll(".directionTrip").forEach((el)=>el.classList.remove("directionTrip__selected"));
            $routeSummary.classList.add("directionTrip__selected");
            this.emit("route_index_changed", this.state.selectedRouteIndex);
        });
    }
    formatDistance(meters) {
        if (meters < 1000) return `${meters} m`;
        else return `${(meters / 1000).toFixed(2)} km`;
    }
    formatTime(seconds) {
        const minutes = Math.round(seconds / 60);
        if (minutes < 60) return `${minutes} mins`;
        else {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            return `${hours} hours ${remainingMinutes} mins`;
        }
    }
    getHTMLForLegs(route) {
        const $instructions = document.createElement("div");
        $instructions.className = "directionTrip__summaryoverview";
        if (route.legs) {
            const $instructionsSteps = route.legs.map((leg, index)=>{
                const $stepContainer = document.createElement("div");
                $stepContainer.className = "step-container";
                const $step = document.createElement("div");
                $step.className = `${leg.travel_mode === `pedestrian` ? "step" : "pill"}`;
                $step.setAttribute("style", `background-color: ${leg.transport.color ? leg.transport.color : `#c0bfbf`}`);
                $step.innerHTML = `<span style="${leg.travel_mode === `pedestrian` ? "background-color: transparent" : `background-color: ${leg.transport.color ? leg.transport.color : `#c0bfbf`}`}" 
                                   class="icon ${leg.travel_mode === `pedestrian` ? `pedestrian` : this.getTransitMode(leg.transport.mode)}"> 
                                    </span><span class="transitduration">${leg.travel_mode === `transit` ? leg.transport.short_name ? leg.transport.short_name : `` : ``}</span>
                ${leg.travel_mode === `pedestrian` ? `<span style="font-weight: bold">${this.formatTimeNumberOnly(leg.duration)}' ${index < route.legs.length - 1 ? "> " : ""}   </span>` : ``} 
                `;
                $stepContainer.appendChild($step);
                leg.travel_mode === `transit` && $step.insertAdjacentHTML("afterend", '<span style="font-weight: bold"> > </span>');
                return $stepContainer;
            });
            $instructions.replaceChildren(...$instructionsSteps);
        }
        return $instructions;
    }
    getHTMLForDetailsLink() {
        const $details = document.createElement("div");
        $details.className = "directionTrip__detailsMsg";
        $details.setAttribute("style", "margin-left:50px;margin-top:10px");
        $details.setAttribute("directionTrip__detailsMsg", "{{ rendererIndex }}");
        $details.innerHTML = `${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.details}`;
        return $details;
    }
    getTransitMode(mode) {
        const transitModes = {
            rail: [
                "highSpeedTrain",
                "intercityTrain",
                "interRegionalTrain",
                "regionalTrain",
                "cityTrain",
                "subway",
                "monorail",
                "inclined"
            ],
            tram: [
                "lightRail"
            ],
            bus: [
                "bus",
                "privateBus",
                "busRapid"
            ],
            ferries: [
                "ferry"
            ],
            aerial: [
                "aerial",
                "flight",
                "spaceship"
            ]
        };
        for(const key in transitModes){
            if (transitModes[key].includes(mode)) return key;
        }
        return "pedestrian";
    }
    formatTimeNumberOnly(seconds) {
        const minutes = Math.round(seconds / 60);
        return minutes;
    }
}






var $049d685ac6677a7f$export$fbd7cb58f6d57767;
(function(TransitRoadbookComponentEvents) {
    TransitRoadbookComponentEvents["BACK"] = "back";
})($049d685ac6677a7f$export$fbd7cb58f6d57767 || ($049d685ac6677a7f$export$fbd7cb58f6d57767 = {}));
class $049d685ac6677a7f$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        if (this.$target.children.length > 0) {
            const node = this.$target.children[0];
            this.$target.removeChild(node);
        }
        this.$element = document.createElement("div");
        this.$element.className = "trouteRoadbook";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.$target.children.length > 0) this.init();
        if (this.state && this.$element && this.state.route) {
            const originText = `${this.state.origin}`;
            const destinationText = `${this.state.destination}`;
            const $roadbookHeader = document.createElement("div");
            $roadbookHeader.className = "trouteRoadbook__header";
            $roadbookHeader.innerHTML = `
                                <span class="trouteRoadbook__headerFromTo">
                                    <div class="trouteRoadbook__headerWaypoint"> ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.from} <span class="routeRoadbook__headerFrom">${originText}</span></div>
                                    <div class="trouteRoadbook__headerWaypoint"> ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.to} <span class="routeRoadbook__headerTo">${destinationText}</span></div>
                                </span>`;
            const $roadbookBody = document.createElement("div");
            $roadbookBody.className = "trouteRoadbook__body";
            $roadbookBody.innerHTML = `
            <div class="trouteRoadbook__summaryHeader">
              <span>
                <span class="delay" >${this.formatTime(this.state.totalDuration)} </span>
                <span class="trouteRoadbook__summarySubtitle">(<span >${this.formatDistance(this.state.totalDistance)}</span>)</span>
              </span>
              <span class="trouteRoadbook__summaryDescription">${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.via} ${this.state.summary}</span>
            </div>`;
            const $instructions = document.createElement("div");
            $instructions.className = "trouteRoadbook__steps";
            this.state.route.legs.forEach((leg)=>{
                const $leg = document.createElement("div");
                $leg.className = "route";
                $leg.innerHTML = `
                <div style="${leg.travel_mode === `pedestrian` ? "background-color: #1aae1d" : `background-color: ${leg.transport.color ? leg.transport.color : `#c0bfbf`}`}" class="icon ${leg.travel_mode === `pedestrian` ? `pedestrian` : this.getTransitMode(leg.transport.mode)}"></div>
                <div class="details">
                    ${leg.travel_mode === "pedestrian" ? `<span>${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.walk}</span><div class='subdetails' style='border-left: 3px dashed #1aae1d'>` : `<span>${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.take} ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.the} ${this.getTransitMode(leg.transport.mode)}</span>
                    <div class="subdetails" style="border-left: 3px solid ${leg.transport.color ? leg.transport.color : `#c0bfbf`}"><p><span class='line'>${leg.transport.name}</span> ${leg.transport.headsign}</p>`}
                    ${leg.travel_mode === "pedestrian" ? "<span></span>" : `<p class='line'>${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.from} ${leg.start_location.name} > ${(0, $07470c5219c7337c$export$180605366c04f0cd)().directions.messages.to} ${leg.end_location.name}</p>`}
                   
                    <span class="duration">${this.formatTime(leg.duration)}</span>
                    <span class="time">${this.formatDistance(leg.distance)}</span>
                    <div class="divider"></div><div>
                </div>
                `;
                $instructions.appendChild($leg);
            });
            $roadbookBody.appendChild($instructions);
            const $backBtn = document.createElement("button");
            $backBtn.className = "trouteRoadbook__headerBack";
            $backBtn.addEventListener("click", ()=>this.emit("back"));
            $roadbookHeader.prepend($backBtn);
            // $roadbookBody.appendChild(this.getHTMLInstructions());
            this.$element.replaceChildren(...[
                $roadbookHeader,
                $roadbookBody
            ]);
            this.styleOnScroll($roadbookBody);
        }
    }
    unMount() {
        if (this.$element) this.$target.removeChild(this.$element);
    }
    getDirectionGoogleMapsUrl(latlng) {
        return `https://www.google.fr/maps/dir//${latlng.lat},${latlng.lng}`;
    }
    getDirectionStepIcon(action) {
        if (action) {
            const stepIconObj = (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.stepsIcon.filter(({ index: index })=>index === action)[0];
            if (stepIconObj) {
                const className = stepIconObj.key.endsWith("Right") ? "reverse" : "";
                return `<div class="trouteRoadbook__stepIcon routeRoadbook__stepIcon${className}">
                            <img alt="${stepIconObj.key}" src="${stepIconObj.icon}">
                        </div>`;
            } else return `<div class="trouteRoadbook__stepIcon routeRoadbook__stepIcon${action}"></div>`;
        }
        return "";
    }
    getDirectionInstructionStep(instructions) {
        if (instructions) {
            if (instructions.summary) return `<div class="trouteRoadbook__stepBody">
                            <span>${instructions.summary}</span>
                        </div>`;
        }
        return "";
    }
    getDirectionInstructionDistance(distance) {
        const $distanceSeperator = document.createElement("div");
        if (distance) {
            $distanceSeperator.className = "trouteRoadbook__stepDistance";
            $distanceSeperator.innerHTML = `<div class="trouteRoadbook__stepDistanceSeparator"></div>
                    <div class="trouteRoadbook__stepDistanceText">${distance}</div>`;
        }
        return $distanceSeperator;
    }
    getWaypoint(address) {
        const $waypoint = document.createElement("div");
        $waypoint.className = "trouteRoadbook__waypoint";
        $waypoint.innerHTML = `<span><h4 class="routeRoadbook__waypointAddress">${address}</h4></span>`;
        return $waypoint;
    }
    getHTMLInstructions() {
        const $instructions = document.createElement("div");
        $instructions.className = "trouteRoadbook__steps";
        return $instructions;
    }
    styleOnScroll($roadbookBody) {
        $roadbookBody === null || $roadbookBody === void 0 ? void 0 : $roadbookBody.addEventListener("scroll", ()=>{
            const scroll = $roadbookBody.scrollTop;
            if (scroll > 0) $roadbookBody.classList.add("active");
            else $roadbookBody.classList.remove("active");
        });
    }
    formatDistance(meters) {
        if (meters < 1000) return `${meters} m`;
        else return `${(meters / 1000).toFixed(2)} km`;
    }
    formatTime(seconds) {
        const minutes = Math.round(seconds / 60);
        if (minutes < 60) return `${minutes} mins`;
        else {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            return `${hours} hours ${remainingMinutes} mins`;
        }
    }
    getTransitMode(mode) {
        const transitModes = {
            train: [
                "highSpeedTrain",
                "intercityTrain",
                "interRegionalTrain",
                "regionalTrain",
                "cityTrain",
                "subway",
                "monorail",
                "inclined"
            ],
            tram: [
                "lightRail"
            ],
            bus: [
                "bus",
                "privateBus",
                "busRapid"
            ],
            ferries: [
                "ferry"
            ],
            aerial: [
                "aerial",
                "flight",
                "spaceship"
            ]
        };
        for(const key in transitModes){
            if (transitModes[key].includes(mode)) return (0, $fb6f3ecaa0346039$export$77ad94ebf1c2b9ed)(key, (0, $07470c5219c7337c$export$180605366c04f0cd)().directions.transit);
        }
        return "pedestrian"; // or you can return 'unknown' or any other default value
    }
}


var $8e875ba49fa0f6f4$export$a7fa205fa3fad685;
(function(DirectionsComponentEvents) {
    DirectionsComponentEvents["MAP_READY"] = "map_ready";
    DirectionsComponentEvents["DIRECTIONS_SHOW"] = "directions_show";
    DirectionsComponentEvents["DESTINATION_CHANGED"] = "destination_changed";
    DirectionsComponentEvents["ROUTES_CHANGED"] = "routes_changed";
    DirectionsComponentEvents["SELECTED_ROUTE_CHANGED"] = "selected_route_changed";
    DirectionsComponentEvents["CLOSE_DIRECTIONS"] = "close_directions";
    DirectionsComponentEvents["ROADBOOK_SHOW"] = "roadbook_show";
    DirectionsComponentEvents["DIRECTIONS_UPDATED"] = "directions_updated";
    DirectionsComponentEvents["TRANSIT_ROUTE_CHANGED"] = "transit_route_changed";
    DirectionsComponentEvents["SELECTED_TRANSIT_ROUTE_CHANGED"] = "selected_transit_route_changed";
})($8e875ba49fa0f6f4$export$a7fa205fa3fad685 || ($8e875ba49fa0f6f4$export$a7fa205fa3fad685 = {}));
class $8e875ba49fa0f6f4$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$target.appendChild(this.$element);
        this.api = new (0, $c3fef9ff564a003b$export$e91aad2e7ca3cca3)({
            apiKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey
        });
    }
    render() {
        if (this.state && this.$element) {
            var _this_state_origin, _this_state_destination;
            this.$element.innerHTML = "";
            this.$target.insertAdjacentHTML("afterbegin", this.getHTMLSkeleton());
            const $closeBtn = document.createElement("button");
            $closeBtn.className = "closeDirections";
            $closeBtn.addEventListener("click", ()=>{
                this.emit("close_directions");
            });
            document.getElementById("directionsHeader").append($closeBtn);
            const travelModesComponent = new (0, $82c102faa09fd15a$export$2e2bcd8739ae039)({
                $target: document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.travelModeContainerID),
                initialState: {
                    selectedTravelMode: this.state.travelMode
                }
            });
            const searchOriginComponent = new (0, $81ab1a4151e5f2b1$export$2e2bcd8739ae039)({
                $target: document.getElementById("directionsOrigin"),
                initialState: {
                    inputID: "originInput",
                    woosmapPublicKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey,
                    searchOptions: (0, $376e204b4320ccbe$export$44487a86467333c3)().multisearch.multiSearchConfig,
                    featuresBtn: [
                        "geolocate",
                        "clear"
                    ]
                }
            });
            const searchDestinationComponent = new (0, $81ab1a4151e5f2b1$export$2e2bcd8739ae039)({
                $target: document.getElementById("directionsDestination"),
                initialState: {
                    inputID: "destinationInput",
                    woosmapPublicKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey,
                    searchOptions: (0, $376e204b4320ccbe$export$44487a86467333c3)().multisearch.multiSearchConfig,
                    featuresBtn: [
                        "clear"
                    ]
                }
            });
            const directionsOptionsComponent = new (0, $6e78ed18e1e28399$export$2e2bcd8739ae039)({
                $target: document.getElementById("directionsOptionsContainer"),
                initialState: {
                    isTransit: false
                }
            });
            this.routesSummaryComponent = new (0, $2cc4a6b94ded5f9b$export$2e2bcd8739ae039)({
                $target: document.getElementById("directionsRoutesContainer"),
                initialState: {
                    routes: [],
                    travelMode: this.state.travelMode,
                    selectedRouteIndex: 0,
                    avoid: this.state.avoid,
                    unitSystem: this.state.unitSystem,
                    isLoading: false
                }
            });
            this.transitSummaryComponent = new (0, $cea17e7de1cf453d$export$2e2bcd8739ae039)({
                $target: document.getElementById("directionsRoutesContainer"),
                initialState: {
                    routes: [],
                    travelMode: this.state.travelMode,
                    selectedRouteIndex: 0,
                    isLoading: false
                }
            });
            if ((_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.name) searchOriginComponent.setLocality(this.state.origin.name);
            if ((_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.name) searchDestinationComponent.setLocality(this.state.destination.name);
            directionsOptionsComponent.on((0, $6e78ed18e1e28399$export$61b319a33691e777).AVOID_UPDATED, (options)=>{
                this.setState({
                    avoid: options
                }, true, ()=>{
                    this.computeRoute();
                });
            });
            directionsOptionsComponent.on((0, $6e78ed18e1e28399$export$61b319a33691e777).UNIT_UPDATED, (unit)=>{
                this.setState({
                    unitSystem: unit
                }, true, ()=>{
                    this.computeRoute();
                });
            });
            searchOriginComponent.on((0, $20c9addaea1cd938$export$bec4f8eff0df0668).SELECTED_LOCALITY, (locality)=>{
                this.setState({
                    origin: {
                        location: locality.location,
                        publicId: locality.publicId,
                        name: locality.name
                    }
                }, true, ()=>{
                    if (!this.state.destination) document.getElementById("destinationInput").focus();
                    if (locality.name) searchOriginComponent.setLocality(locality.name);
                    this.computeRoute();
                });
            });
            searchOriginComponent.on((0, $81ab1a4151e5f2b1$export$bec4f8eff0df0668).SELECTED_STORE, (locality)=>{
                this.setState({
                    origin: {
                        location: {
                            lat: locality.geometry.coordinates[1],
                            lng: locality.geometry.coordinates[0]
                        },
                        publicId: locality.properties.store_id,
                        name: locality.properties.name
                    }
                }, true, ()=>{
                    if (!this.state.destination) document.getElementById("destinationInput").focus();
                    searchOriginComponent.setLocality(locality.properties.name);
                    this.computeRoute();
                });
            });
            searchDestinationComponent.on((0, $20c9addaea1cd938$export$bec4f8eff0df0668).SELECTED_LOCALITY, (locality)=>{
                this.setState({
                    destination: {
                        location: locality.location,
                        publicId: locality.publicId,
                        name: locality.name
                    }
                }, true, ()=>{
                    if (!this.state.origin) document.getElementById("originInput").focus();
                    if (locality.name) searchDestinationComponent.setLocality(locality.name);
                    this.computeRoute();
                });
            });
            searchDestinationComponent.on((0, $81ab1a4151e5f2b1$export$bec4f8eff0df0668).SELECTED_STORE, (locality)=>{
                console.log(locality);
                this.setState({
                    destination: {
                        location: {
                            lat: locality.geometry.coordinates[1],
                            lng: locality.geometry.coordinates[0]
                        },
                        publicId: locality.properties.store_id,
                        name: locality.properties.name
                    }
                }, true, ()=>{
                    if (!this.state.origin) document.getElementById("originInput").focus();
                    searchDestinationComponent.setLocality(locality.properties.name);
                    this.computeRoute();
                });
            });
            searchOriginComponent.on((0, $20c9addaea1cd938$export$bec4f8eff0df0668).SEARCH_CLEAR, ()=>{
                this.setState({
                    origin: undefined
                }, true, ()=>{
                    this.cleanRoutes();
                });
            });
            searchDestinationComponent.on((0, $20c9addaea1cd938$export$bec4f8eff0df0668).SEARCH_CLEAR, ()=>{
                this.setState({
                    destination: undefined
                }, true, ()=>{
                    this.cleanRoutes();
                });
            });
            travelModesComponent.on((0, $82c102faa09fd15a$export$5685af560c13eb53).TRAVEL_MODE_CHANGED, (travelModeKey)=>{
                this.emit((0, $6e78ed18e1e28399$export$61b319a33691e777).TRAVEL_MODE_CHANGED, travelModeKey);
                this.setState({
                    travelMode: travelModeKey,
                    avoid: []
                }, true, ()=>{
                    this.computeRoute();
                });
            });
            this.on("map_ready", (map)=>{
                this.map = map;
                this.initDirectionRenderer();
                this.initTransitRenderer();
            });
            this.on((0, $6e78ed18e1e28399$export$61b319a33691e777).TRAVEL_MODE_CHANGED, (mode)=>{
                directionsOptionsComponent.setState({
                    isTransit: mode === "TRANSIT" ? true : false
                });
            });
            this.on("destination_changed", ()=>{
                var _this_state_origin, _this_state_destination;
                if (this.state.origin && this.state.destination) this.computeRoute();
                if ((_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.name) searchOriginComponent.setLocality(this.state.origin.name);
                if ((_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.name) searchDestinationComponent.setLocality(this.state.destination.name);
                this.emit("directions_updated", this.state);
            });
            this.on("directions_show", ()=>{
                var _this_state_directionsResult_routes, _this_state_directionsResult, _this_state_transitResult_routes, _this_state_transitResult;
                if ((_this_state_directionsResult = this.state.directionsResult) === null || _this_state_directionsResult === void 0 ? void 0 : (_this_state_directionsResult_routes = _this_state_directionsResult.routes) === null || _this_state_directionsResult_routes === void 0 ? void 0 : _this_state_directionsResult_routes.length) {
                    this.directionsRenderer.setMap(this.map);
                    this.directionMarkers.forEach((marker)=>{
                        marker.setMap(this.map);
                    });
                    this.fitToRouteBounds(this.bounds);
                } else if ((_this_state_transitResult = this.state.transitResult) === null || _this_state_transitResult === void 0 ? void 0 : (_this_state_transitResult_routes = _this_state_transitResult.routes) === null || _this_state_transitResult_routes === void 0 ? void 0 : _this_state_transitResult_routes.length) {
                    this.transitRenderer.setMap(this.map);
                    this.directionMarkers.forEach((marker)=>{
                        marker.setMap(this.map);
                    });
                    this.fitToRouteBounds(this.bounds);
                }
                this.emit("directions_updated", this.state);
            });
            let routeRoadbookComponent;
            this.routesSummaryComponent.on((0, $2cc4a6b94ded5f9b$export$ebf4dc7348200b05).ROADBOOK_SHOW, ()=>{
                if (this.state.directionsResult) {
                    if (!routeRoadbookComponent) {
                        routeRoadbookComponent = new (0, $c41cf0e9f2a5c100$export$2e2bcd8739ae039)({
                            $target: document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.roadbookContainerID),
                            initialState: {
                                route: this.state.directionsResult.routes[this.state.selectedRouteIndex]
                            }
                        });
                        routeRoadbookComponent.on((0, $c41cf0e9f2a5c100$export$da1f36ab6d8337bc).BACK, ()=>{
                            this.emit("directions_show");
                        });
                    } else routeRoadbookComponent.setState({
                        route: this.state.directionsResult.routes[this.state.selectedRouteIndex]
                    });
                }
                this.emit("roadbook_show");
            });
            let transitRoadbookComponent;
            this.transitSummaryComponent.on((0, $cea17e7de1cf453d$export$f72d68ecd7c295b1).ROADBOOK_SHOW, ()=>{
                if (this.state.transitResult) {
                    var _selectedRoute_legs_find;
                    const selectedRoute = this.state.transitResult.routes[this.state.selectedRouteIndex];
                    const totalDistance = selectedRoute.legs.reduce((sum, { distance: distance })=>sum + distance, 0);
                    const startName = ((_selectedRoute_legs_find = selectedRoute.legs.find((leg)=>leg.start_location && leg.start_location.name !== null)) === null || _selectedRoute_legs_find === void 0 ? void 0 : _selectedRoute_legs_find.start_location.name) || "Walking";
                    const summary = startName;
                    const totalDuration = selectedRoute.duration;
                    if (!transitRoadbookComponent) {
                        var _this_state_origin, _this_state_destination;
                        transitRoadbookComponent = new (0, $049d685ac6677a7f$export$2e2bcd8739ae039)({
                            $target: document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.roadbookContainerID),
                            initialState: {
                                route: this.state.transitResult.routes[this.state.selectedRouteIndex],
                                origin: (_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.name,
                                destination: (_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.name,
                                summary: summary,
                                totalDistance: totalDistance,
                                totalDuration: totalDuration
                            }
                        });
                        transitRoadbookComponent.on((0, $049d685ac6677a7f$export$fbd7cb58f6d57767).BACK, ()=>{
                            this.emit("directions_show");
                        });
                    } else {
                        var _this_state_origin1, _this_state_destination1;
                        transitRoadbookComponent.render();
                        transitRoadbookComponent.setState({
                            route: this.state.transitResult.routes[this.state.selectedRouteIndex],
                            origin: (_this_state_origin1 = this.state.origin) === null || _this_state_origin1 === void 0 ? void 0 : _this_state_origin1.name,
                            destination: (_this_state_destination1 = this.state.destination) === null || _this_state_destination1 === void 0 ? void 0 : _this_state_destination1.name,
                            summary: summary,
                            totalDistance: totalDistance,
                            totalDuration: totalDuration
                        });
                    }
                }
                this.emit("roadbook_show");
            });
            this.on("routes_changed", ()=>{
                var _this_state_directionsResult, _this_state_origin, _this_state_destination, _this_state_directionsResult1;
                var _this_state_directionsResult_routes, _this_state_origin_name, _this_state_destination_name, _this_state_directionsResult_error_message;
                this.routesSummaryComponent.setState({
                    routes: (_this_state_directionsResult_routes = (_this_state_directionsResult = this.state.directionsResult) === null || _this_state_directionsResult === void 0 ? void 0 : _this_state_directionsResult.routes) !== null && _this_state_directionsResult_routes !== void 0 ? _this_state_directionsResult_routes : [],
                    travelMode: this.state.travelMode,
                    selectedRouteIndex: this.state.selectedRouteIndex,
                    origin: (_this_state_origin_name = (_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.name) !== null && _this_state_origin_name !== void 0 ? _this_state_origin_name : "",
                    destination: (_this_state_destination_name = (_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.name) !== null && _this_state_destination_name !== void 0 ? _this_state_destination_name : "",
                    avoid: this.state.avoid,
                    unitSystem: this.state.unitSystem,
                    error: (_this_state_directionsResult_error_message = (_this_state_directionsResult1 = this.state.directionsResult) === null || _this_state_directionsResult1 === void 0 ? void 0 : _this_state_directionsResult1.error_message) !== null && _this_state_directionsResult_error_message !== void 0 ? _this_state_directionsResult_error_message : "",
                    isLoading: false
                });
                this.transitSummaryComponent.setState({
                    routes: [],
                    travelMode: this.state.travelMode,
                    selectedRouteIndex: 0,
                    isLoading: false
                });
                this.emit("directions_show");
                this.emit("directions_updated", this.state);
            });
            this.on("transit_route_changed", ()=>{
                var _this_state_transitResult, _this_state_origin, _this_state_destination;
                var _this_state_transitResult_routes, _this_state_origin_name, _this_state_destination_name;
                this.transitSummaryComponent.setState({
                    routes: (_this_state_transitResult_routes = (_this_state_transitResult = this.state.transitResult) === null || _this_state_transitResult === void 0 ? void 0 : _this_state_transitResult.routes) !== null && _this_state_transitResult_routes !== void 0 ? _this_state_transitResult_routes : [],
                    travelMode: this.state.travelMode,
                    selectedRouteIndex: this.state.selectedRouteIndex,
                    origin: (_this_state_origin_name = (_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.name) !== null && _this_state_origin_name !== void 0 ? _this_state_origin_name : "",
                    destination: (_this_state_destination_name = (_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.name) !== null && _this_state_destination_name !== void 0 ? _this_state_destination_name : "",
                    isLoading: false
                });
                this.routesSummaryComponent.setState({
                    routes: [],
                    travelMode: this.state.travelMode,
                    selectedRouteIndex: 0,
                    avoid: this.state.avoid,
                    unitSystem: this.state.unitSystem,
                    isLoading: false
                });
                this.emit("directions_show");
                this.emit("directions_updated", this.state);
            });
            this.on("selected_route_changed", ()=>{
                this.routesSummaryComponent.selectRoute(this.state.selectedRouteIndex);
                if (this.state.directionsResult && routeRoadbookComponent) routeRoadbookComponent.setState({
                    route: this.state.directionsResult.routes[this.state.selectedRouteIndex]
                });
            });
            this.on("selected_transit_route_changed", ()=>{
                this.transitSummaryComponent.selectRoute(this.state.selectedRouteIndex);
                if (this.state.transitResult && transitRoadbookComponent) {
                    var _selectedRoute_legs_find, _this_state_origin, _this_state_destination;
                    const selectedRoute = this.state.transitResult.routes[this.state.selectedRouteIndex];
                    const totalDistance = selectedRoute.legs.reduce((sum, { distance: distance })=>sum + distance, 0);
                    const startName = ((_selectedRoute_legs_find = selectedRoute.legs.find((leg)=>leg.start_location && leg.start_location.name !== null)) === null || _selectedRoute_legs_find === void 0 ? void 0 : _selectedRoute_legs_find.start_location.name) || "Walking";
                    const summary = startName;
                    const totalDuration = selectedRoute.duration;
                    transitRoadbookComponent.setState({
                        route: this.state.transitResult.routes[this.state.selectedRouteIndex],
                        origin: (_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.name,
                        destination: (_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.name,
                        summary: summary,
                        totalDistance: totalDistance,
                        totalDuration: totalDuration
                    });
                }
            });
            this.routesSummaryComponent.on((0, $2cc4a6b94ded5f9b$export$ebf4dc7348200b05).ROUTE_INDEX_CHANGED, (selectedRouteIndex)=>{
                this.setState({
                    selectedRouteIndex: selectedRouteIndex
                }, true, ()=>{
                    this.directionsRenderer.setRouteIndex(this.state.selectedRouteIndex);
                });
            });
            this.transitSummaryComponent.on((0, $cea17e7de1cf453d$export$f72d68ecd7c295b1).ROUTE_INDEX_CHANGED, (selectedRouteIndex)=>{
                this.setState({
                    selectedRouteIndex: selectedRouteIndex
                }, true, ()=>{
                    this.transitRenderer.setRouteIndex(this.state.selectedRouteIndex);
                });
            });
            this.on("close_directions", ()=>{
                this.cleanRoutes(true);
            });
        }
    }
    initDirectionRenderer() {
        this.directionsRenderer = new woosmap.map.DirectionsRenderer({
            preserveViewport: true
        });
        this.directionsRenderer.addListener("routeIndex_changed", ()=>{
            this.setState({
                selectedRouteIndex: this.directionsRenderer.get("routeIndex")
            }, true, ()=>{
                this.emit("selected_route_changed");
            });
        });
        this.computeRoute();
    }
    initTransitRenderer() {
        this.transitRenderer = new woosmap.map.TransitRenderer({
            preserveViewport: true
        });
        this.transitRenderer.addListener("routeIndex_changed", ()=>{
            this.setState({
                selectedRouteIndex: this.transitRenderer.get("routeIndex")
            }, true, ()=>{
                this.emit("selected_transit_route_changed");
            });
        });
        this.computeRoute();
    }
    computeRoute() {
        if (this.state.origin && this.state.destination && this.state.travelMode !== "TRANSIT") {
            var _this_state_origin, _this_state_destination;
            this.routesSummaryComponent.setState({
                isLoading: true
            });
            this.api.distance.route({
                origin: ((_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.location) ? `${this.state.origin.location.lat},${this.state.origin.location.lng}` : "",
                destination: ((_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.location) ? `${this.state.destination.location.lat},${this.state.destination.location.lng}` : "",
                mode: this.state.travelMode,
                units: this.state.unitSystem,
                alternatives: this.state.provideRouteAlternatives,
                avoid: this.state.avoid.join("|"),
                details: "full",
                language: (0, $07470c5219c7337c$export$3814be8b8b1016be)().toLowerCase()
            }).then((response)=>{
                this.setState({
                    directionsResult: response,
                    transitResult: {
                        routes: [],
                        status: "NOT_FOUND"
                    },
                    selectedRouteIndex: 0
                }, true, ()=>{
                    this.updateRoutes();
                });
            }).catch((exception)=>{
                console.error(exception);
                this.setState({
                    directionsResult: {
                        routes: [],
                        status: "NOT_FOUND"
                    },
                    selectedRouteIndex: 0
                }, true);
                this.cleanRoutes();
            }).finally(()=>{
                this.emit("routes_changed");
            });
        } else if (this.state.origin && this.state.destination) {
            var _this_state_origin1, _this_state_origin2, _this_state_origin3, _this_state_destination1, _this_state_destination2, _this_state_destination3;
            const transitService = new woosmap.map.TransitService();
            let transitRequest = {
                origin: ((_this_state_origin1 = this.state.origin) === null || _this_state_origin1 === void 0 ? void 0 : _this_state_origin1.location) && {
                    lat: (_this_state_origin2 = this.state.origin) === null || _this_state_origin2 === void 0 ? void 0 : _this_state_origin2.location.lat,
                    lng: (_this_state_origin3 = this.state.origin) === null || _this_state_origin3 === void 0 ? void 0 : _this_state_origin3.location.lng
                },
                destination: ((_this_state_destination1 = this.state.destination) === null || _this_state_destination1 === void 0 ? void 0 : _this_state_destination1.location) && {
                    lat: (_this_state_destination2 = this.state.destination) === null || _this_state_destination2 === void 0 ? void 0 : _this_state_destination2.location.lat,
                    lng: (_this_state_destination3 = this.state.destination) === null || _this_state_destination3 === void 0 ? void 0 : _this_state_destination3.location.lng
                }
            };
            const excludedModes = [];
            if (this.state.avoid && this.state.avoid.length > 0) {
                const avoidModes = this.state.avoid;
                avoidModes.forEach((mode)=>{
                    (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.transitModes[mode].forEach((subMode)=>{
                        excludedModes.push("-" + subMode);
                    });
                });
            }
            if (excludedModes.length > 0) transitRequest = {
                ...transitRequest,
                modes: excludedModes
            };
            this.transitSummaryComponent.setState({
                isLoading: true
            });
            transitService.route(transitRequest).then((response)=>{
                this.setState({
                    transitResult: response,
                    directionsResult: {
                        routes: [],
                        status: "NOT_FOUND"
                    },
                    selectedRouteIndex: 0
                }, true, ()=>{
                    this.updateTransitRoutes();
                });
            }).catch((error)=>{
                console.error("Error calculating transit route:", error);
            }).finally(()=>{
                this.emit("transit_route_changed");
            });
        }
    }
    cleanRoutes(preserveMarkers) {
        this.directionsRenderer.setMap(null);
        this.transitRenderer.setMap(null);
        this.removeMarkers();
        if (!preserveMarkers) this.directionMarkers = [];
    }
    updateRoutes() {
        var _this_state_directionsResult_routes, _this_state_directionsResult;
        if ((_this_state_directionsResult = this.state.directionsResult) === null || _this_state_directionsResult === void 0 ? void 0 : (_this_state_directionsResult_routes = _this_state_directionsResult.routes) === null || _this_state_directionsResult_routes === void 0 ? void 0 : _this_state_directionsResult_routes.length) {
            var _this_state_origin, _this_state_destination;
            this.cleanRoutes();
            this.bounds = new woosmap.map.LatLngBounds();
            for (const element of this.state.directionsResult.routes){
                const route = element;
                this.bounds.union(new woosmap.map.LatLngBounds(route.bounds.northeast, route.bounds.southwest));
                if (route.overview_polyline) {
                    const encodedPolyline = route.overview_polyline;
                    const decodedPolyline = (0, $fb6f3ecaa0346039$export$b89605802fcf91d2)(encodedPolyline.points);
                    route.overview_path = decodedPolyline.map((latlng)=>new woosmap.map.LatLng(latlng[0], latlng[1]));
                }
            }
            this.directionsRenderer.setDirections(this.state.directionsResult);
            this.directionsRenderer.setMap(this.map);
            this.fitToRouteBounds(this.bounds);
            if (((_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.location) && ((_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.location)) {
                var _this_state_origin_name;
                this.addMarkerLabel(this.state.origin.location, (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.iconsDirections.start, (_this_state_origin_name = this.state.origin.name) !== null && _this_state_origin_name !== void 0 ? _this_state_origin_name : "");
                var _this_state_destination_name;
                this.addMarkerLabel(this.state.destination.location, (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.iconsDirections.end, (_this_state_destination_name = this.state.destination.name) !== null && _this_state_destination_name !== void 0 ? _this_state_destination_name : "");
            }
        } else this.cleanRoutes();
    }
    updateTransitRoutes() {
        var _this_state_transitResult_routes, _this_state_transitResult;
        if ((_this_state_transitResult = this.state.transitResult) === null || _this_state_transitResult === void 0 ? void 0 : (_this_state_transitResult_routes = _this_state_transitResult.routes) === null || _this_state_transitResult_routes === void 0 ? void 0 : _this_state_transitResult_routes.length) {
            var _this_state_transitResult1, _this_state_transitResult2, _this_state_origin, _this_state_destination;
            this.cleanRoutes();
            this.bounds = new window.woosmap.map.LatLngBounds();
            this.bounds = (_this_state_transitResult1 = this.state.transitResult) === null || _this_state_transitResult1 === void 0 ? void 0 : _this_state_transitResult1.routes[this.state.selectedRouteIndex].bounds;
            this.transitRenderer.setRoutes((_this_state_transitResult2 = this.state.transitResult) === null || _this_state_transitResult2 === void 0 ? void 0 : _this_state_transitResult2.routes);
            this.transitRenderer.setMap(this.map);
            this.fitToRouteBounds(this.bounds);
            if (((_this_state_origin = this.state.origin) === null || _this_state_origin === void 0 ? void 0 : _this_state_origin.location) && ((_this_state_destination = this.state.destination) === null || _this_state_destination === void 0 ? void 0 : _this_state_destination.location)) {
                var _this_state_origin_name;
                this.addMarkerLabel(this.state.origin.location, (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.iconsDirections.start, (_this_state_origin_name = this.state.origin.name) !== null && _this_state_origin_name !== void 0 ? _this_state_origin_name : "");
                var _this_state_destination_name;
                this.addMarkerLabel(this.state.destination.location, (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.iconsDirections.end, (_this_state_destination_name = this.state.destination.name) !== null && _this_state_destination_name !== void 0 ? _this_state_destination_name : "");
            }
        } else this.cleanRoutes();
    }
    removeMarkers() {
        this.directionMarkers.forEach((marker)=>{
            marker.setMap(null);
        });
    }
    addMarkerLabel(positon, icon, label) {
        const iconWidth = icon.scaledSize.width;
        const modifiedName = label.replace("Stage", (0, $07470c5219c7337c$export$180605366c04f0cd)().stores.name.Stage);
        icon.labelOrigin = new woosmap.map.Point(Math.ceil((0, $fb6f3ecaa0346039$export$37827d046293d309)(label) / 2 + iconWidth + 2), Math.round(iconWidth / 2));
        this.directionMarkers.push(new woosmap.map.Marker({
            label: {
                text: modifiedName,
                className: "markerLabel"
            },
            position: positon,
            icon: icon,
            map: this.map
        }));
    }
    fitToRouteBounds(bounds) {
        this.map.fitBounds(bounds, this.state.padding);
    }
    getHTMLSkeleton() {
        return `
        <div id="directionsInputs">
            <div id="directionsHeader">
                <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.travelModeContainerID}"></div>
            </div>
            <div id="odInputs">
                <div>
                    <div id="directionsOrigin">
                    </div>
                    <div id="directionsDestination">
                    </div>
                </div>
            </div>
        </div>
        <div id="directionsOptionsContainer"></div>
        <div id="directionsResults">
            <div id="directionsOptions"></div>
            <div id="directionsRoutesContainer"></div>
        </div>`;
    }
    constructor(...args){
        super(...args);
        this.directionMarkers = [];
    }
}








var $781fdfbf8a4d8045$export$489a40757d2e9df5;
(function(StoreLocatorEvents) {
    StoreLocatorEvents["PADDING_CHANGED"] = "padding_changed";
})($781fdfbf8a4d8045$export$489a40757d2e9df5 || ($781fdfbf8a4d8045$export$489a40757d2e9df5 = {}));
var $781fdfbf8a4d8045$export$5ea5b4f66bfb2f2f;
(function(StoreLocatorViews) {
    StoreLocatorViews["DETAILS_VIEW"] = "details_view";
    StoreLocatorViews["LIST_VIEW"] = "list_view";
    StoreLocatorViews["DIRECTIONS_VIEW"] = "directions_view";
    StoreLocatorViews["ROADBOOK_VIEW"] = "roadbook_view";
    StoreLocatorViews["RESET_MAP"] = "reset_map";
})($781fdfbf8a4d8045$export$5ea5b4f66bfb2f2f || ($781fdfbf8a4d8045$export$5ea5b4f66bfb2f2f = {}));
class $781fdfbf8a4d8045$export$2e2bcd8739ae039 extends (0, $8fa72f61f485ea6c$export$2e2bcd8739ae039) {
    init() {
    // this.urlParameterManager = new URLParameterManager();
    }
    render() {
        (0, $07470c5219c7337c$export$e6103b0362967aab)(this.state.locale || (0, $07470c5219c7337c$export$9a2147b3808d4c6b));
        (0, $376e204b4320ccbe$export$940a7873bb071df8)(this.state.config);
        this.$target.innerHTML = "";
        this.$target.insertAdjacentHTML("afterbegin", this.getHTMLSkeleton());
        this.$sidebarContentContainer = document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.sidebarContentContainerID);
        this.styleOnScroll();
        let searchLocation = undefined;
        const urlParams = (0, $fb6f3ecaa0346039$export$a360ab73c4a4e345)(window.location.search);
        if (urlParams && urlParams["search"] && urlParams["lat"] && urlParams["lng"]) searchLocation = {
            name: urlParams["search"],
            location: {
                lat: urlParams["lat"],
                lng: urlParams["lng"]
            }
        };
        else if (urlParams && urlParams["search"]) this.getGeometryForSearchedTerm(urlParams["search"].toString()).then((response)=>{
            if (response && response.results.length > 0) {
                var _response_results__geometry, _response_results__geometry1;
                searchLocation = {
                    name: urlParams["search"],
                    location: {
                        lat: (_response_results__geometry = response.results[0].geometry) === null || _response_results__geometry === void 0 ? void 0 : _response_results__geometry.location.lat,
                        lng: (_response_results__geometry1 = response.results[0].geometry) === null || _response_results__geometry1 === void 0 ? void 0 : _response_results__geometry1.location.lng
                    }
                };
                this.searchComponent.setState({
                    selectedLocality: searchLocation
                }, true, ()=>{
                    this.searchComponent.selectLocality();
                });
            }
        });
        let filterQueryString = undefined;
        if (urlParams && urlParams["date"] && (0, $fb6f3ecaa0346039$export$f394dc66b1ba32c3)(urlParams["date"].toString())) filterQueryString = urlParams["date"].toString();
        this.searchComponent = new (0, $81ab1a4151e5f2b1$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.searchWrapperID),
            initialState: {
                inputID: (0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.searchInputID,
                woosmapPublicKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey,
                searchOptions: (0, $376e204b4320ccbe$export$44487a86467333c3)().multisearch.multiSearchConfig,
                featuresBtn: [
                    "search",
                    "clear",
                    "geolocate"
                ],
                selectedLocality: searchLocation
            }
        });
        this.mapComponent = new (0, $70dedddd8cc8a209$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.mapContainerID),
            initialState: {
                woosmapPublicKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey,
                mapOptions: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.mapOptions,
                storesStyle: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.storesStyle,
                padding: this.state.padding,
                location: this.urlParameterManager && this.urlParameterManager.getLocation()
            }
        });
        this.directionsComponent = new (0, $8e875ba49fa0f6f4$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.directionsContainerID),
            initialState: {
                padding: this.state.padding,
                provideRouteAlternatives: (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.directionsOptions.provideRouteAlternatives,
                travelMode: (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.directionsOptions.travelMode,
                unitSystem: (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.directionsOptions.unitSystem,
                avoid: (0, $376e204b4320ccbe$export$44487a86467333c3)().directions.directionsOptions.avoid,
                selectedRouteIndex: 0
            }
        });
        this.storesListComponent = new (0, $7ef822eee1334c42$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.listStoresContainerID),
            initialState: {}
        });
        this.storeDetailsComponent = new (0, $3e361f38741262ad$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.detailsStoreContainerID),
            initialState: {
                store: undefined
            }
        });
        this.filterComponent = new (0, $f5cfc18e60f3f1c9$export$2e2bcd8739ae039)({
            $target: document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.filterPanelContainerID),
            initialState: {
                activeFilters: filterQueryString
            }
        });
        this.filterComponent.on((0, $f5cfc18e60f3f1c9$export$f5c69f55b3b1a646).FILTERS_UPDATED, (queryString)=>{
            this.storesListComponent.setState({
                query: queryString
            }, true, ()=>this.storesListComponent.emit((0, $7ef822eee1334c42$export$e16b04041918aede).QUERY_CHANGED));
            this.mapComponent.setState({
                query: queryString
            }, true, ()=>this.mapComponent.emit((0, $70dedddd8cc8a209$export$715fed9478e7c158).FILTERS_UPDATED));
        });
        // if(urlParams && urlParams['date']){
        //     this.filterComponent.setState({activeFilters: `user.date:="${urlParams['date']}"`}, true, () => {
        //         this.filterComponent.emit(FilterComponentEvents.FILTERS_UPDATED, `user.date:="${urlParams['date']}"`);
        //     })
        // }
        this.searchComponent.on((0, $20c9addaea1cd938$export$bec4f8eff0df0668).SELECTED_LOCALITY, (locality)=>{
            var _this_urlParameterManager;
            this.urlParameterManager && ((_this_urlParameterManager = this.urlParameterManager) === null || _this_urlParameterManager === void 0 ? void 0 : _this_urlParameterManager.setLocality(locality));
            this.storeDetailsComponent.setState({
                store: undefined
            });
            this.storesListComponent.setState({
                nearbyLocation: locality.location
            }, true, ()=>this.storesListComponent.emit((0, $7ef822eee1334c42$export$e16b04041918aede).LOCALITY_CHANGED));
            // this.directionsComponent.setState({
            //     destination: { location: locality.location, name: locality.name }
            // }, true);
            this.directionsComponent.setState({
                origin: {
                    location: locality.location,
                    name: locality.name
                }
            }, true);
            this.setListView();
        });
        this.searchComponent.on((0, $81ab1a4151e5f2b1$export$bec4f8eff0df0668).SELECTED_STORE, (locality)=>{
            this.storeDetailsComponent.setState({
                store: locality
            });
            this.setDetailsView();
            this.mapComponent.setState({
                selectedStore: locality
            }, true, ()=>this.mapComponent.selectStore());
        // this.directionsComponent.setState({
        //     origin: {location: {lat: locality.geometry.coordinates[1], lng: locality.geometry.coordinates[0]}, name: locality.properties.name}
        // }, true);
        });
        this.searchComponent.on((0, $20c9addaea1cd938$export$bec4f8eff0df0668).SEARCH_CLEAR, ()=>{
            var _this_urlParameterManager;
            this.urlParameterManager && ((_this_urlParameterManager = this.urlParameterManager) === null || _this_urlParameterManager === void 0 ? void 0 : _this_urlParameterManager.setLocality(undefined));
            this.storesListComponent.setState({
                nearbyLocation: undefined
            }, true, ()=>this.storesListComponent.emit((0, $7ef822eee1334c42$export$e16b04041918aede).LOCALITY_CHANGED));
            this.mapComponent.setState({
                selectedStore: undefined,
                nearbyLocation: undefined,
                stores: []
            }, true, ()=>this.mapComponent.emit((0, $70dedddd8cc8a209$export$715fed9478e7c158).STORES_CHANGED));
            this.directionsComponent.setState({
                origin: undefined
            }, true);
            this.setListView();
            this.setUserPosition(undefined);
        // this.resetMap();
        // this.mapComponent.setState({stores: this.majorStages.features}, true, () => {
        //     this.mapComponent.emit(MapComponentEvents.STORES_CHANGED);
        // });
        // this.mapComponent.setState({location: {latitude: 46.3, longitude: 3.2, zoom: 6}});
        });
        this.storesListComponent.on((0, $7ef822eee1334c42$export$e16b04041918aede).STORES_CHANGED, ({ stores: stores, nearbyLocation: nearbyLocation })=>{
            this.mapComponent.setState({
                selectedStore: undefined
            }, true);
            this.mapComponent.setState({
                stores: stores,
                nearbyLocation: nearbyLocation
            }, true, ()=>{
                this.mapComponent.emit((0, $70dedddd8cc8a209$export$715fed9478e7c158).STORES_CHANGED);
                this.setUserPosition(nearbyLocation);
            });
            this.setListView();
        });
        this.storesListComponent.on((0, $7ef822eee1334c42$export$e16b04041918aede).RESET, ()=>{
            this.mapComponent.setState({
                selectedStore: undefined,
                nearbyLocation: undefined,
                stores: []
            }, true, ()=>this.mapComponent.emit((0, $70dedddd8cc8a209$export$715fed9478e7c158).STORES_CHANGED));
        });
        this.storesListComponent.on((0, $7ef822eee1334c42$export$e16b04041918aede).STORE_SELECTED, (selectedStore)=>{
            var _this_urlParameterManager;
            this.urlParameterManager && ((_this_urlParameterManager = this.urlParameterManager) === null || _this_urlParameterManager === void 0 ? void 0 : _this_urlParameterManager.setStoreId(selectedStore.properties.store_id));
            this.storeDetailsComponent.setState({
                store: selectedStore
            });
            this.mapComponent.setState({
                selectedStore: selectedStore
            }, true, ()=>this.mapComponent.selectStore());
            this.setDetailsView();
        });
        this.storesListComponent.on((0, $7ef822eee1334c42$export$e16b04041918aede).STORE_MOUSEENTER, (0, $fb6f3ecaa0346039$export$61fc7d43ac8f84b0)((selectedStore)=>{
            this.mapComponent.selectStoreOnDataOverlay(selectedStore);
        }, 50));
        this.storesListComponent.on((0, $7ef822eee1334c42$export$e16b04041918aede).STORE_MOUSELEAVE, (0, $fb6f3ecaa0346039$export$61fc7d43ac8f84b0)(()=>{
            if (this.$target.className !== "details_view") this.mapComponent.unselectStoreOnDataOverlay();
        }, 50));
        this.storeDetailsComponent.on((0, $3e361f38741262ad$export$fc087719351cdb12).BACK, ()=>{
            this.mapComponent.setState({
                selectedStore: undefined
            }, true, ()=>this.mapComponent.emit((0, $70dedddd8cc8a209$export$715fed9478e7c158).STORE_UNSELECTED));
            this.setListView();
        });
        this.mapComponent.on((0, $70dedddd8cc8a209$export$715fed9478e7c158).MAP_READY, ()=>{
            const $attributionElem = document.querySelector(".mapboxgl-ctrl-attrib");
            if ($attributionElem) $attributionElem.classList.remove("mapboxgl-compact");
            this.directionsComponent.emit((0, $8e875ba49fa0f6f4$export$a7fa205fa3fad685).MAP_READY, this.mapComponent.map);
            this.setChildrenInitialState();
        });
        this.mapComponent.on((0, $70dedddd8cc8a209$export$715fed9478e7c158).MAP_IDLE, ()=>{
            this.emit((0, $70dedddd8cc8a209$export$715fed9478e7c158).MAP_IDLE);
        });
        this.mapComponent.on((0, $70dedddd8cc8a209$export$715fed9478e7c158).LOCATION_CHANGED, (location)=>{
            this.urlParameterManager && this.urlParameterManager.setLocation(location);
        });
        this.mapComponent.on((0, $70dedddd8cc8a209$export$715fed9478e7c158).STORE_UNSELECTED, ()=>{
            this.urlParameterManager && this.urlParameterManager.setStoreId(undefined);
            if (this.$target.className === "details_view") this.setListView();
        });
        this.storeDetailsComponent.on((0, $3e361f38741262ad$export$fc087719351cdb12).DIRECTIONS_SHOW, (selectedStore)=>{
            const destination = {
                name: selectedStore.properties.name,
                location: {
                    lat: selectedStore.geometry.coordinates[1],
                    lng: selectedStore.geometry.coordinates[0]
                }
            };
            if (this.directionsComponent.checkNeedUpdate({
                destination: destination
            })) this.directionsComponent.setState({
                destination: destination
            }, true, ()=>this.directionsComponent.emit((0, $8e875ba49fa0f6f4$export$a7fa205fa3fad685).DESTINATION_CHANGED));
            else this.directionsComponent.emit((0, $8e875ba49fa0f6f4$export$a7fa205fa3fad685).DIRECTIONS_SHOW);
            this.setDirectionsView();
        });
        this.directionsComponent.on((0, $8e875ba49fa0f6f4$export$a7fa205fa3fad685).DIRECTIONS_UPDATED, (directionState)=>{
            this.urlParameterManager && this.urlParameterManager.setDirection({
                from: directionState.origin,
                to: directionState.destination
            });
        });
        this.mapComponent.on((0, $70dedddd8cc8a209$export$715fed9478e7c158).STORE_SELECTED, (selectedStore)=>{
            if (selectedStore) {
                this.urlParameterManager && this.urlParameterManager.setStoreId(selectedStore.properties.store_id);
                this.storeDetailsComponent.setState({
                    store: selectedStore
                });
                if (this.$target.className === "directions_view" || this.$target.className === "roadbook_view") {
                    const destination = {
                        name: selectedStore.properties.name,
                        location: {
                            lat: selectedStore.geometry.coordinates[1],
                            lng: selectedStore.geometry.coordinates[0]
                        }
                    };
                    this.directionsComponent.setState({
                        destination: destination
                    }, true, ()=>{
                        this.directionsComponent.emit((0, $8e875ba49fa0f6f4$export$a7fa205fa3fad685).DESTINATION_CHANGED);
                    });
                } else this.setDetailsView();
            } else {
                this.urlParameterManager && this.urlParameterManager.setStoreId(undefined);
                this.setDetailsView();
            }
        });
        this.on("padding_changed", ()=>{
            this.directionsComponent.setState({
                padding: this.state.padding
            }, true);
            this.mapComponent.setState({
                padding: this.state.padding
            }, true);
        });
        this.directionsComponent.on((0, $8e875ba49fa0f6f4$export$a7fa205fa3fad685).ROADBOOK_SHOW, ()=>{
            this.setRoadbookView();
        });
        this.directionsComponent.on((0, $8e875ba49fa0f6f4$export$a7fa205fa3fad685).DIRECTIONS_SHOW, ()=>{
            this.setDirectionsView();
        });
        this.directionsComponent.on((0, $8e875ba49fa0f6f4$export$a7fa205fa3fad685).CLOSE_DIRECTIONS, ()=>{
            if (this.urlParameterManager && this.urlParameterManager.getDirection()) this.urlParameterManager.setDirection(undefined);
            if (this.urlParameterManager && this.urlParameterManager.getStoreId()) this.setDetailsView();
            else this.setListView();
            this.mapComponent.setState({
                selectedStore: undefined,
                nearbyLocation: undefined,
                stores: []
            }, true, ()=>this.mapComponent.emit((0, $70dedddd8cc8a209$export$715fed9478e7c158).STORES_CHANGED));
        });
        window.addEventListener("resize", (0, $fb6f3ecaa0346039$export$61fc7d43ac8f84b0)(()=>{
            this.managePadding();
        }, 100));
        this.managePadding();
    }
    setChildrenInitialState() {
        if (this.urlParameterManager && this.urlParameterManager.getStoreId()) {
            const api = new (0, $c3fef9ff564a003b$export$e91aad2e7ca3cca3)({
                apiKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey
            });
            api.stores.searchStores({
                query: `idstore:="${this.urlParameterManager.getStoreId()}"`
            }).then((response)=>{
                const selectedStore = response === null || response === void 0 ? void 0 : response.features[0];
                this.storeDetailsComponent.setState({
                    store: selectedStore
                });
                this.setDetailsView();
                this.mapComponent.setState({
                    selectedStore: selectedStore
                }, true, ()=>this.mapComponent.selectStore());
            }).catch((exception)=>{
                console.error(exception);
            });
        } else if (this.urlParameterManager && this.urlParameterManager.getLocality()) this.searchComponent.setState({
            selectedLocality: this.urlParameterManager.getLocality()
        }, true, ()=>{
            this.searchComponent.selectLocality();
        });
        else if (this.urlParameterManager && this.urlParameterManager.getDirection()) {
            const direction = this.urlParameterManager.getDirection();
            let directionState = {};
            if (direction === null || direction === void 0 ? void 0 : direction.from) directionState = {
                ...directionState,
                origin: direction.from
            };
            if (direction === null || direction === void 0 ? void 0 : direction.to) directionState = {
                ...directionState,
                destination: direction.to
            };
            this.directionsComponent.setState(directionState, true, ()=>{
                this.directionsComponent.emit((0, $8e875ba49fa0f6f4$export$a7fa205fa3fad685).DESTINATION_CHANGED);
                this.setDirectionsView();
            });
        } else this.setListView();
    }
    setUserPosition(position) {
        if (!position && this.userLocationMarker) {
            this.userLocationMarker.setMap(null);
            return;
        }
        if (position) {
            if (!this.userLocationMarker) this.userLocationMarker = new woosmap.map.Marker({
                position: position,
                icon: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.userLocationIconOptions
            });
            else this.userLocationMarker.setPosition(position);
            this.userLocationMarker.setMap(this.mapComponent.map);
        }
    }
    setDetailsView() {
        this.$target.className = "details_view";
        this.$sidebarContentContainer.scrollTo(0, 0);
    }
    setListView() {
        this.$target.className = "list_view";
        this.$sidebarContentContainer.scrollTo(0, 0);
    }
    setDirectionsView() {
        this.$target.className = "directions_view";
    }
    setRoadbookView() {
        this.$target.className = "roadbook_view";
    }
    styleOnScroll() {
        var _this_$sidebarContentContainer;
        (_this_$sidebarContentContainer = this.$sidebarContentContainer) === null || _this_$sidebarContentContainer === void 0 ? void 0 : _this_$sidebarContentContainer.addEventListener("scroll", ()=>{
            const scroll = this.$sidebarContentContainer.scrollTop;
            if (scroll > 0) this.$sidebarContentContainer.classList.add("active");
            else this.$sidebarContentContainer.classList.remove("active");
        });
    }
    managePadding() {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        //On Mobile, padding from bottom to 56% of Store Locator height
        (0, $376e204b4320ccbe$export$44487a86467333c3)().map.mapPaddings.mobile.bottom = Math.round(document.getElementById((0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.mapContainerID).clientHeight * 0.56);
        if (width >= (0, $376e204b4320ccbe$export$44487a86467333c3)().map.mobileBreakPoint) this.setState({
            padding: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.mapPaddings.full
        }, true, ()=>{
            this.emit("padding_changed");
        });
        else this.setState({
            padding: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.mapPaddings.mobile
        }, true, ()=>{
            this.emit("padding_changed");
        });
    }
    getHTMLSkeleton() {
        return `
        <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.mapContainerID}"></div>
        <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.sidebarContainerID}">
           <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.searchContainerID}">
              <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.searchWrapperID}"></div>
              <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.suggestionListID}"></div>
           </div>
           <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.sidebarContentContainerID}">
               <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.filterPanelContainerID}"></div>
               <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.listStoresContainerID}"></div>
               <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.detailsStoreContainerID}"></div>
           </div>
        <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.directionsContainerID}"></div>   
        <div id="${(0, $376e204b4320ccbe$export$44487a86467333c3)().selectors.roadbookContainerID}"></div>
        </div>`;
    }
    async getGeometryForSearchedTerm(query) {
        this.api = new (0, $c3fef9ff564a003b$export$e91aad2e7ca3cca3)({
            apiKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey
        });
        const params = {
            address: query
        };
        const response = await this.api.geocode.geocode(params);
        return response;
    }
    async filterStoresByDate(query) {
        this.api = new (0, $c3fef9ff564a003b$export$e91aad2e7ca3cca3)({
            apiKey: (0, $376e204b4320ccbe$export$44487a86467333c3)().map.woosmapPublicKey
        });
        const searchParams = {
            query: query
        };
        const filteredStores = await this.api.stores.searchStores(searchParams);
        return filteredStores;
    }
}


window.woosmapLocator = (0, $781fdfbf8a4d8045$export$2e2bcd8739ae039);


//# sourceMappingURL=index.39f8c876.js.map
